/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountAnalyticArticleDailyDetailParams,
  AccountAnalyticArticleHourlyDetailParams,
  AccountAnalyticBroadcastDetailParams,
  AccountAnalyticBroadcastReportDetailParams,
  AccountAnalyticFollowerDateDetailParams,
  AccountAnalyticFollowerRangeDetailParams,
  AccountArticleGroupArticleUpdatePayload,
  AccountArticleGroupCreatePayload,
  AccountArticleGroupDetailParams,
  AccountAssignCreatePayload,
  AccountAutoReplyCreatePayload,
  AccountAutoReplyDetailParams,
  AccountAutoReplyPartialUpdatePayload,
  AccountBroadcastCreatePayload,
  AccountBroadcastDetailParams,
  AccountBroadcastPartialUpdatePayload,
  AccountBroadcastPreviewCreatePayload,
  AccountConversationDetailParams,
  AccountCreatePayload,
  AccountDetailParams,
  AccountFollowerBatchPartialUpdatePayload,
  AccountFollowerEstimateTargetsCreatePayload,
  AccountFollowerPartialUpdatePayload,
  AccountFollowerSearchDetailParams,
  AccountFollowerTagCreatePayload,
  AccountFollowerTagDetailParams,
  AccountFollowerTagPartialUpdatePayload,
  AccountInboxDetailParams,
  AccountInboxSendMessageCreatePayload,
  AccountLocationDetailParams,
  AccountMaterialCreatePayload,
  AccountMaterialDetailParams,
  AccountMaterialGroupCreatePayload,
  AccountMaterialGroupDetailParams,
  AccountMaterialGroupPartialUpdatePayload,
  AccountMaterialPartialUpdatePayload,
  AccountMenuCreatePayload,
  AccountMessageDetailParams,
  AccountOrgMemberDetailParams,
  AccountPartialUpdatePayload,
  AccountRetractCreatePayload,
  AccountScheduleMenuDetailParams,
  AccountScheduleMenuPartialUpdatePayload,
  MemberDetailParams,
  MemberInviteCancelCreatePayload,
  MemberInviteCreatePayload,
  MemberInviteResendCreatePayload,
  MemberPartialUpdatePayload,
  PatchOrgPayload,
  PostOrgPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Org<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Organization
   * @name GetOrg
   * @summary Show organization
   * @request GET:/org/{org_id}
   * @secure
   * @response `200` `{ data: { id: number, name: string, display_name_en: string, display_name_zh_hant: string | null, status: string, created_at: number | null, role_name: string } }` Return the details of the organization with the ID provided
   */
  getOrg = (orgId: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          name: string;
          display_name_en: string;
          display_name_zh_hant: string | null;
          status: string;
          created_at: number | null;
          role_name: string;
        };
      },
      any
    >({
      path: `/org/${orgId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Organization
   * @name PatchOrg
   * @summary Update organization setting
   * @request PATCH:/org/{org_id}
   * @secure
   * @response `200` `{ data: { id: number, name: string, display_name_en: string, display_name_zh_hant: string | null, status: string, created_at: number | null, role_name: string } }` Return the updated details of the organization with the ID provided
   */
  patchOrg = (orgId: number, data: PatchOrgPayload, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          name: string;
          display_name_en: string;
          display_name_zh_hant: string | null;
          status: string;
          created_at: number | null;
          role_name: string;
        };
      },
      any
    >({
      path: `/org/${orgId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name PostOrg
   * @summary Create organization account
   * @request POST:/org/{org_id}
   * @secure
   * @response `200` `{ data: { id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] } }` Return the details of the account created
   */
  postOrg = (orgId: number, data: PostOrgPayload, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          member_ids: number[];
          member_admin: number[];
          member_editor: number[];
          member_analyst: number[];
          member_guest: number[];
          role_name: string;
          follower_count: number;
          organization_ids: number[];
        };
      },
      any
    >({
      path: `/org/${orgId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountDetail
   * @summary Show accounts under an organization
   * @request GET:/org/{org_id}/account
   * @secure
   * @response `200` `{ data: ({ id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Return a list of accounts under the organization with the ID provided
   */
  accountDetail = ({ orgId, ...query }: AccountDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          member_ids: number[];
          member_admin: number[];
          member_editor: number[];
          member_analyst: number[];
          member_guest: number[];
          role_name: string;
          follower_count: number;
          organization_ids: number[];
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountCreate
   * @summary Bind account to organization
   * @request POST:/org/{org_id}/account
   * @secure
   * @response `200` `{ data: { id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, role_name: string, follower_count: number } }` Return the account detail
   */
  accountCreate = (orgId: number, data: AccountCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          role_name: string;
          follower_count: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name MemberDetail
   * @summary Show members of an organization
   * @request GET:/org/{org_id}/member
   * @secure
   * @response `200` `{ data: ({ id: number, name: string, email: string, is_valid: number, is_active: number, language: string, last_login_at: number | null, last_interact_acc: number | null, organization_id: (number)[], organization_role: string, accounts: ({ id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] })[] })[], links: ({ first: string | null, last: string | null, prev: string | null, next: string | null }), meta: ({ current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number }) }` Return an index of members of the organization with the ID provided
   */
  memberDetail = ({ orgId, ...query }: MemberDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          name: string;
          email: string;
          is_valid: number;
          is_active: number;
          language: string;
          last_login_at: number | null;
          last_interact_acc: number | null;
          organization_id: number[];
          organization_role: string;
          accounts: {
            id: number;
            status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
            is_oversea: boolean;
            auth_type: "COMPONENT" | "MANUAL";
            nickname: string | null;
            user_name: string | null;
            is_verified: number | null;
            service_type: "SERVICE" | "SUBSCRIPTION";
            app_id: string | null;
            app_secret: string | null;
            qrcode_url: string | null;
            profile_url: string | null;
            connector_token: string | null;
            connector_url: string | null;
            aes_key: string | null;
            hash_id: string | null;
            is_open_store: number | null;
            is_open_scan: number | null;
            is_open_pay: number | null;
            is_open_card: number | null;
            is_open_shake: number | null;
            is_historical: number | null;
            is_verified_quali: number | null;
            is_verified_name: number | null;
            verify_source: string | null;
            func_info: string | null;
            business_info: string | null;
            permissions: {
              message_management: boolean;
              user_management: boolean;
              account_service: boolean;
              web_service: boolean;
              wechat_store: boolean;
              customer_service: boolean;
              broadcast_and_notice: boolean;
              wechat_card: boolean;
              wechat_scan: boolean;
              wechat_wifi: boolean;
              material_management: boolean;
              wechat_shake: boolean;
              wechat_poi: boolean;
              wechat_payment: boolean;
              custom_menu: boolean;
            };
            member_ids: number[];
            member_admin: number[];
            member_editor: number[];
            member_analyst: number[];
            member_guest: number[];
            role_name: string;
            follower_count: number;
            organization_ids: number[];
          }[];
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/member`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountDetail2
   * @summary Show organization account
   * @request GET:/org/{org_id}/account/{acc_id}
   * @originalName accountDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] } }` Return the details of the account specified
   */
  accountDetail2 = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          member_ids: number[];
          member_admin: number[];
          member_editor: number[];
          member_analyst: number[];
          member_guest: number[];
          role_name: string;
          follower_count: number;
          organization_ids: number[];
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountPartialUpdate
   * @summary Update organization account
   * @request PATCH:/org/{org_id}/account/{acc_id}
   * @secure
   * @response `200` `{ data: { id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, role_name: string, follower_count: number } }` Return the updated details of the account specified
   */
  accountPartialUpdate = (
    orgId: number,
    accId: number,
    data: AccountPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          role_name: string;
          follower_count: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountDelete
   * @summary Delete organization's account
   * @request DELETE:/org/{org_id}/account/{acc_id}
   * @secure
   * @response `200` `{ id: number }` Return the ID of the account deleted
   */
  accountDelete = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<{ id: number }, any>({
      path: `/org/${orgId}/account/${accId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountHistoryDetail
   * @request GET:/org/{org_id}/account/{acc_id}/history
   * @secure
   * @response `200` `{ data: ({ id: number, authorizer_admin_id: number | null, admin_id: number | null, organization_id: number | null, account_id: number | null, action: "CREATE" | "UPDATE" | "REMOVE" | "INVITE" | "ACCEPT_INVITE" | "RESEND_INVITE" | "CANCEL_INVITE" | "UPDATE_ROLE", from_value: (any)[] | null, to_value: (any)[] | null, time: number | null })[] }` Return the history of the account specified
   */
  accountHistoryDetail = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          authorizer_admin_id: number | null;
          admin_id: number | null;
          organization_id: number | null;
          account_id: number | null;
          action:
            | "CREATE"
            | "UPDATE"
            | "REMOVE"
            | "INVITE"
            | "ACCEPT_INVITE"
            | "RESEND_INVITE"
            | "CANCEL_INVITE"
            | "UPDATE_ROLE";
          from_value: any[] | null;
          to_value: any[] | null;
          time: number | null;
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/history`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountAssignCreate
   * @summary Assign member to organization account
   * @request POST:/org/{org_id}/account/{acc_id}/assign
   * @secure
   * @response `200` `{ data: { id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, role_name: string, follower_count: number } }` Return the account details
   */
  accountAssignCreate = (orgId: number, accId: number, data: AccountAssignCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          role_name: string;
          follower_count: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/assign`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountRetractCreate
   * @summary Retract member from organization account
   * @request POST:/org/{org_id}/account/{acc_id}/retract
   * @secure
   * @response `200` `{ data: { id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, role_name: string, follower_count: number } }` Return the account details
   */
  accountRetractCreate = (
    orgId: number,
    accId: number,
    data: AccountRetractCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          role_name: string;
          follower_count: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/retract`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountOrgMemberDetail
   * @summary Get member of organization account
   * @request GET:/org/{org_id}/account/{acc_id}/org-member
   * @secure
   * @response `200` `{ data: ({ id: number, name: string, email: string, is_valid: number, is_active: number, language: string, last_login_at: number | null, last_interact_acc: number | null, organization_id: (number)[], organization_role: string, accounts: ({ id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] })[] })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Return a list of members
   */
  accountOrgMemberDetail = ({ orgId, accId, ...query }: AccountOrgMemberDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          name: string;
          email: string;
          is_valid: number;
          is_active: number;
          language: string;
          last_login_at: number | null;
          last_interact_acc: number | null;
          organization_id: number[];
          organization_role: string;
          accounts: {
            id: number;
            status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
            is_oversea: boolean;
            auth_type: "COMPONENT" | "MANUAL";
            nickname: string | null;
            user_name: string | null;
            is_verified: number | null;
            service_type: "SERVICE" | "SUBSCRIPTION";
            app_id: string | null;
            app_secret: string | null;
            qrcode_url: string | null;
            profile_url: string | null;
            connector_token: string | null;
            connector_url: string | null;
            aes_key: string | null;
            hash_id: string | null;
            is_open_store: number | null;
            is_open_scan: number | null;
            is_open_pay: number | null;
            is_open_card: number | null;
            is_open_shake: number | null;
            is_historical: number | null;
            is_verified_quali: number | null;
            is_verified_name: number | null;
            verify_source: string | null;
            func_info: string | null;
            business_info: string | null;
            permissions: {
              message_management: boolean;
              user_management: boolean;
              account_service: boolean;
              web_service: boolean;
              wechat_store: boolean;
              customer_service: boolean;
              broadcast_and_notice: boolean;
              wechat_card: boolean;
              wechat_scan: boolean;
              wechat_wifi: boolean;
              material_management: boolean;
              wechat_shake: boolean;
              wechat_poi: boolean;
              wechat_payment: boolean;
              custom_menu: boolean;
            };
            member_ids: number[];
            member_admin: number[];
            member_editor: number[];
            member_analyst: number[];
            member_guest: number[];
            role_name: string;
            follower_count: number;
            organization_ids: number[];
          }[];
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/org-member`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu
   * @name AccountMenuDetail
   * @summary Display current menu
   * @request GET:/org/{org_id}/account/{acc_id}/menu
   * @secure
   * @response `200` `{ data: { id: number, button: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, sub_button?: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }))[] }))[], is_custom_menu: boolean, scheduled_at?: number } }` Return current menu
   */
  accountMenuDetail = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          button: ({
            type?:
              | "click"
              | "view"
              | "material_id"
              | "article_group_id"
              | "scancode_push"
              | "scancode_waitmsg"
              | "pic_sysphoto"
              | "pic_photo_or_album"
              | "pic_weixin"
              | "location_select"
              | "article_view_limited"
              | "miniprogram"
              | null;
            id?: number;
            name?: string;
            url?: string | null;
            appid?: string | null;
            pagepath?: string | null;
          } & {
            message?: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            };
            sub_button?: ({
              type?:
                | "click"
                | "view"
                | "material_id"
                | "article_group_id"
                | "scancode_push"
                | "scancode_waitmsg"
                | "pic_sysphoto"
                | "pic_photo_or_album"
                | "pic_weixin"
                | "location_select"
                | "article_view_limited"
                | "miniprogram"
                | null;
              id?: number;
              name?: string;
              url?: string | null;
              appid?: string | null;
              pagepath?: string | null;
            } & {
              message?: {
                id: number;
                message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
                created_at: number | null;
                messageable: {
                  text_content?: string | null;
                  title?: string | null;
                  description?: string | null;
                  material_id?: number | null;
                  thumb_material_id?: number | null;
                  article_group_id?: number | null;
                } & {
                  material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  thumb_material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  article_group?: {
                    id?: number;
                    media_id?: string;
                    status?:
                      | "DRAFT"
                      | "PUBLISHED"
                      | "Publish failed, WeChat blocked all articles access"
                      | "Publish failed"
                      | "Rejected by WeChat"
                      | "Publishing, Pending for WeChat approval"
                      | "WeChat rejected. Reason: Not original content."
                      | "All article deleted by user.";
                    articles?: {
                      id: number;
                      title: string;
                      digest: string | null;
                      author: string | null;
                      content: string;
                      thumb_material_id: number | null;
                      thumb_material: {
                        id: number;
                        group_id: number | null;
                        file_name: string;
                        display_name: string;
                        cloud_storage_object_id: string;
                        cloud_storage_object_params: string | null;
                        cloud_storage_url: string;
                        wx_media_type: "video" | "voice" | "image";
                        wx_media_id: string;
                        video_title: string | null;
                        video_description: string | null;
                        wxapi_uploaded_at?: number;
                        created_at: number;
                        updated_at: number | null;
                      };
                      url: string | null;
                      thumb_url: string;
                      content_source_url: string | null;
                      need_open_comment: boolean;
                      only_fans_can_comment: boolean;
                      create_time: number;
                      update_time: number | null;
                    }[];
                  };
                };
              };
            })[];
          })[];
          is_custom_menu: boolean;
          scheduled_at?: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/menu`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Menu
   * @name AccountMenuCreate
   * @summary Create menu
   * @request POST:/org/{org_id}/account/{acc_id}/menu
   * @secure
   * @response `200` `{ data: { id: number, button: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, sub_button?: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }))[] }))[], is_custom_menu: boolean, scheduled_at?: number } }` Return created menu
   */
  accountMenuCreate = (orgId: number, accId: number, data: AccountMenuCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          button: ({
            type?:
              | "click"
              | "view"
              | "material_id"
              | "article_group_id"
              | "scancode_push"
              | "scancode_waitmsg"
              | "pic_sysphoto"
              | "pic_photo_or_album"
              | "pic_weixin"
              | "location_select"
              | "article_view_limited"
              | "miniprogram"
              | null;
            id?: number;
            name?: string;
            url?: string | null;
            appid?: string | null;
            pagepath?: string | null;
          } & {
            message?: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            };
            sub_button?: ({
              type?:
                | "click"
                | "view"
                | "material_id"
                | "article_group_id"
                | "scancode_push"
                | "scancode_waitmsg"
                | "pic_sysphoto"
                | "pic_photo_or_album"
                | "pic_weixin"
                | "location_select"
                | "article_view_limited"
                | "miniprogram"
                | null;
              id?: number;
              name?: string;
              url?: string | null;
              appid?: string | null;
              pagepath?: string | null;
            } & {
              message?: {
                id: number;
                message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
                created_at: number | null;
                messageable: {
                  text_content?: string | null;
                  title?: string | null;
                  description?: string | null;
                  material_id?: number | null;
                  thumb_material_id?: number | null;
                  article_group_id?: number | null;
                } & {
                  material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  thumb_material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  article_group?: {
                    id?: number;
                    media_id?: string;
                    status?:
                      | "DRAFT"
                      | "PUBLISHED"
                      | "Publish failed, WeChat blocked all articles access"
                      | "Publish failed"
                      | "Rejected by WeChat"
                      | "Publishing, Pending for WeChat approval"
                      | "WeChat rejected. Reason: Not original content."
                      | "All article deleted by user.";
                    articles?: {
                      id: number;
                      title: string;
                      digest: string | null;
                      author: string | null;
                      content: string;
                      thumb_material_id: number | null;
                      thumb_material: {
                        id: number;
                        group_id: number | null;
                        file_name: string;
                        display_name: string;
                        cloud_storage_object_id: string;
                        cloud_storage_object_params: string | null;
                        cloud_storage_url: string;
                        wx_media_type: "video" | "voice" | "image";
                        wx_media_id: string;
                        video_title: string | null;
                        video_description: string | null;
                        wxapi_uploaded_at?: number;
                        created_at: number;
                        updated_at: number | null;
                      };
                      url: string | null;
                      thumb_url: string;
                      content_source_url: string | null;
                      need_open_comment: boolean;
                      only_fans_can_comment: boolean;
                      create_time: number;
                      update_time: number | null;
                    }[];
                  };
                };
              };
            })[];
          })[];
          is_custom_menu: boolean;
          scheduled_at?: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/menu`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Schedule Menu
   * @name AccountScheduleMenuDetail
   * @summary Display a listing of unpublished menus on schedule
   * @request GET:/org/{org_id}/account/{acc_id}/schedule-menu
   * @secure
   * @response `200` `{ data: ({ id: number, button: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, sub_button?: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }))[] }))[], scheduled_at: number | null, is_custom_menu: boolean, is_published: boolean, published_at: number, status: ("ACTIVE" | "INACTIVE") })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Return a list of unpublished menus on schedule
   */
  accountScheduleMenuDetail = (
    { orgId, accId, ...query }: AccountScheduleMenuDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          button: ({
            type?:
              | "click"
              | "view"
              | "material_id"
              | "article_group_id"
              | "scancode_push"
              | "scancode_waitmsg"
              | "pic_sysphoto"
              | "pic_photo_or_album"
              | "pic_weixin"
              | "location_select"
              | "article_view_limited"
              | "miniprogram"
              | null;
            id?: number;
            name?: string;
            url?: string | null;
            appid?: string | null;
            pagepath?: string | null;
          } & {
            message?: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            };
            sub_button?: ({
              type?:
                | "click"
                | "view"
                | "material_id"
                | "article_group_id"
                | "scancode_push"
                | "scancode_waitmsg"
                | "pic_sysphoto"
                | "pic_photo_or_album"
                | "pic_weixin"
                | "location_select"
                | "article_view_limited"
                | "miniprogram"
                | null;
              id?: number;
              name?: string;
              url?: string | null;
              appid?: string | null;
              pagepath?: string | null;
            } & {
              message?: {
                id: number;
                message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
                created_at: number | null;
                messageable: {
                  text_content?: string | null;
                  title?: string | null;
                  description?: string | null;
                  material_id?: number | null;
                  thumb_material_id?: number | null;
                  article_group_id?: number | null;
                } & {
                  material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  thumb_material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  article_group?: {
                    id?: number;
                    media_id?: string;
                    status?:
                      | "DRAFT"
                      | "PUBLISHED"
                      | "Publish failed, WeChat blocked all articles access"
                      | "Publish failed"
                      | "Rejected by WeChat"
                      | "Publishing, Pending for WeChat approval"
                      | "WeChat rejected. Reason: Not original content."
                      | "All article deleted by user.";
                    articles?: {
                      id: number;
                      title: string;
                      digest: string | null;
                      author: string | null;
                      content: string;
                      thumb_material_id: number | null;
                      thumb_material: {
                        id: number;
                        group_id: number | null;
                        file_name: string;
                        display_name: string;
                        cloud_storage_object_id: string;
                        cloud_storage_object_params: string | null;
                        cloud_storage_url: string;
                        wx_media_type: "video" | "voice" | "image";
                        wx_media_id: string;
                        video_title: string | null;
                        video_description: string | null;
                        wxapi_uploaded_at?: number;
                        created_at: number;
                        updated_at: number | null;
                      };
                      url: string | null;
                      thumb_url: string;
                      content_source_url: string | null;
                      need_open_comment: boolean;
                      only_fans_can_comment: boolean;
                      create_time: number;
                      update_time: number | null;
                    }[];
                  };
                };
              };
            })[];
          })[];
          scheduled_at: number | null;
          is_custom_menu: boolean;
          is_published: boolean;
          published_at: number;
          status: "ACTIVE" | "INACTIVE";
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/schedule-menu`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Schedule Menu
   * @name AccountScheduleMenuDetail2
   * @summary Get scheduled and unpublished menu by ID
   * @request GET:/org/{org_id}/account/{acc_id}/schedule-menu/{menu_id}
   * @originalName accountScheduleMenuDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, button: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, sub_button?: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }))[] }))[], scheduled_at: number | null, is_custom_menu: boolean, is_published: boolean, published_at: number, status: ("ACTIVE" | "INACTIVE") } }` Return the details of the menu
   */
  accountScheduleMenuDetail2 = (orgId: number, accId: number, menuId: string, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          button: ({
            type?:
              | "click"
              | "view"
              | "material_id"
              | "article_group_id"
              | "scancode_push"
              | "scancode_waitmsg"
              | "pic_sysphoto"
              | "pic_photo_or_album"
              | "pic_weixin"
              | "location_select"
              | "article_view_limited"
              | "miniprogram"
              | null;
            id?: number;
            name?: string;
            url?: string | null;
            appid?: string | null;
            pagepath?: string | null;
          } & {
            message?: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            };
            sub_button?: ({
              type?:
                | "click"
                | "view"
                | "material_id"
                | "article_group_id"
                | "scancode_push"
                | "scancode_waitmsg"
                | "pic_sysphoto"
                | "pic_photo_or_album"
                | "pic_weixin"
                | "location_select"
                | "article_view_limited"
                | "miniprogram"
                | null;
              id?: number;
              name?: string;
              url?: string | null;
              appid?: string | null;
              pagepath?: string | null;
            } & {
              message?: {
                id: number;
                message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
                created_at: number | null;
                messageable: {
                  text_content?: string | null;
                  title?: string | null;
                  description?: string | null;
                  material_id?: number | null;
                  thumb_material_id?: number | null;
                  article_group_id?: number | null;
                } & {
                  material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  thumb_material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  article_group?: {
                    id?: number;
                    media_id?: string;
                    status?:
                      | "DRAFT"
                      | "PUBLISHED"
                      | "Publish failed, WeChat blocked all articles access"
                      | "Publish failed"
                      | "Rejected by WeChat"
                      | "Publishing, Pending for WeChat approval"
                      | "WeChat rejected. Reason: Not original content."
                      | "All article deleted by user.";
                    articles?: {
                      id: number;
                      title: string;
                      digest: string | null;
                      author: string | null;
                      content: string;
                      thumb_material_id: number | null;
                      thumb_material: {
                        id: number;
                        group_id: number | null;
                        file_name: string;
                        display_name: string;
                        cloud_storage_object_id: string;
                        cloud_storage_object_params: string | null;
                        cloud_storage_url: string;
                        wx_media_type: "video" | "voice" | "image";
                        wx_media_id: string;
                        video_title: string | null;
                        video_description: string | null;
                        wxapi_uploaded_at?: number;
                        created_at: number;
                        updated_at: number | null;
                      };
                      url: string | null;
                      thumb_url: string;
                      content_source_url: string | null;
                      need_open_comment: boolean;
                      only_fans_can_comment: boolean;
                      create_time: number;
                      update_time: number | null;
                    }[];
                  };
                };
              };
            })[];
          })[];
          scheduled_at: number | null;
          is_custom_menu: boolean;
          is_published: boolean;
          published_at: number;
          status: "ACTIVE" | "INACTIVE";
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/schedule-menu/${menuId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Schedule Menu
   * @name AccountScheduleMenuPartialUpdate
   * @summary Update scheduled and unpublished menu
   * @request PATCH:/org/{org_id}/account/{acc_id}/schedule-menu/{menu_id}
   * @secure
   * @response `200` `{ data: { id: number, button: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, sub_button?: (({ type?: "click" | "view" | "material_id" | "article_group_id" | "scancode_push" | "scancode_waitmsg" | "pic_sysphoto" | "pic_photo_or_album" | "pic_weixin" | "location_select" | "article_view_limited" | "miniprogram" | null, id?: number, name?: string, url?: string | null, appid?: string | null, pagepath?: string | null } & { message?: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }))[] }))[], scheduled_at: number | null, is_custom_menu: boolean, is_published: boolean, published_at: number, status: ("ACTIVE" | "INACTIVE") } }` Successfully updated menu
   */
  accountScheduleMenuPartialUpdate = (
    orgId: number,
    accId: number,
    menuId: string,
    data: AccountScheduleMenuPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          button: ({
            type?:
              | "click"
              | "view"
              | "material_id"
              | "article_group_id"
              | "scancode_push"
              | "scancode_waitmsg"
              | "pic_sysphoto"
              | "pic_photo_or_album"
              | "pic_weixin"
              | "location_select"
              | "article_view_limited"
              | "miniprogram"
              | null;
            id?: number;
            name?: string;
            url?: string | null;
            appid?: string | null;
            pagepath?: string | null;
          } & {
            message?: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            };
            sub_button?: ({
              type?:
                | "click"
                | "view"
                | "material_id"
                | "article_group_id"
                | "scancode_push"
                | "scancode_waitmsg"
                | "pic_sysphoto"
                | "pic_photo_or_album"
                | "pic_weixin"
                | "location_select"
                | "article_view_limited"
                | "miniprogram"
                | null;
              id?: number;
              name?: string;
              url?: string | null;
              appid?: string | null;
              pagepath?: string | null;
            } & {
              message?: {
                id: number;
                message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
                created_at: number | null;
                messageable: {
                  text_content?: string | null;
                  title?: string | null;
                  description?: string | null;
                  material_id?: number | null;
                  thumb_material_id?: number | null;
                  article_group_id?: number | null;
                } & {
                  material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  thumb_material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  article_group?: {
                    id?: number;
                    media_id?: string;
                    status?:
                      | "DRAFT"
                      | "PUBLISHED"
                      | "Publish failed, WeChat blocked all articles access"
                      | "Publish failed"
                      | "Rejected by WeChat"
                      | "Publishing, Pending for WeChat approval"
                      | "WeChat rejected. Reason: Not original content."
                      | "All article deleted by user.";
                    articles?: {
                      id: number;
                      title: string;
                      digest: string | null;
                      author: string | null;
                      content: string;
                      thumb_material_id: number | null;
                      thumb_material: {
                        id: number;
                        group_id: number | null;
                        file_name: string;
                        display_name: string;
                        cloud_storage_object_id: string;
                        cloud_storage_object_params: string | null;
                        cloud_storage_url: string;
                        wx_media_type: "video" | "voice" | "image";
                        wx_media_id: string;
                        video_title: string | null;
                        video_description: string | null;
                        wxapi_uploaded_at?: number;
                        created_at: number;
                        updated_at: number | null;
                      };
                      url: string | null;
                      thumb_url: string;
                      content_source_url: string | null;
                      need_open_comment: boolean;
                      only_fans_can_comment: boolean;
                      create_time: number;
                      update_time: number | null;
                    }[];
                  };
                };
              };
            })[];
          })[];
          scheduled_at: number | null;
          is_custom_menu: boolean;
          is_published: boolean;
          published_at: number;
          status: "ACTIVE" | "INACTIVE";
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/schedule-menu/${menuId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Schedule Menu
   * @name AccountScheduleMenuDelete
   * @summary Delete scheduled and unpublished menu by ID
   * @request DELETE:/org/{org_id}/account/{acc_id}/schedule-menu/{menu_id}
   * @secure
   * @response `200` `void` Successfully deleted scheduled menu
   */
  accountScheduleMenuDelete = (orgId: number, accId: number, menuId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/schedule-menu/${menuId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticArticleDailyDetail
   * @summary Show daily stats of article traffic
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/article/daily
   * @secure
   * @response `200` `{ data: ({ id: number, date_i: number, hour: number | null, account_id: number, int_page_read_user: number, int_page_read_cnt: number, ori_page_read_user: number, ori_page_read_cnt: number, share_user: number, share_cnt: number, share_scene_friend: number, share_scene_moment: number, share_scene_tencent_weibo: number, share_scene_others: number, favor_user: number, favor_cnt: number })[] }` Successfully received daily stats of article traffic
   */
  accountAnalyticArticleDailyDetail = (
    { orgId, accId, ...query }: AccountAnalyticArticleDailyDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          date_i: number;
          hour: number | null;
          account_id: number;
          int_page_read_user: number;
          int_page_read_cnt: number;
          ori_page_read_user: number;
          ori_page_read_cnt: number;
          share_user: number;
          share_cnt: number;
          share_scene_friend: number;
          share_scene_moment: number;
          share_scene_tencent_weibo: number;
          share_scene_others: number;
          favor_user: number;
          favor_cnt: number;
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/article/daily`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticArticleHourlyDetail
   * @summary Show hourly stats of article traffic
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/article/hourly
   * @secure
   * @response `200` `{ data: ({ id: number, date_i: number, hour: number | null, account_id: number, int_page_read_user: number, int_page_read_cnt: number, ori_page_read_user: number, ori_page_read_cnt: number, share_user: number, share_cnt: number, share_scene_friend: number, share_scene_moment: number, share_scene_tencent_weibo: number, share_scene_others: number, favor_user: number, favor_cnt: number })[] }` Successfully received hourly stats of article traffic
   */
  accountAnalyticArticleHourlyDetail = (
    { orgId, accId, ...query }: AccountAnalyticArticleHourlyDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          date_i: number;
          hour: number | null;
          account_id: number;
          int_page_read_user: number;
          int_page_read_cnt: number;
          ori_page_read_user: number;
          ori_page_read_cnt: number;
          share_user: number;
          share_cnt: number;
          share_scene_friend: number;
          share_scene_moment: number;
          share_scene_tencent_weibo: number;
          share_scene_others: number;
          favor_user: number;
          favor_cnt: number;
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/article/hourly`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticBroadcastDetail
   * @summary Display a listing of the broadcast stat
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/broadcast
   * @secure
   * @response `200` `{ data: ({ account_id: number, broadcast_id: number | null, broadcast_date: string, broadcast_date_i: number, latest_stat_date_i: number, wx_msgid: string, target_user: number | null, int_page_read_user: number, int_page_read_count: number, ori_page_read_user: number, ori_page_read_count: number, share_user: number, share_count: number, add_to_fav_user: number, add_to_fav_count: number, int_page_from_session_read_user: number | null, int_page_from_session_read_count: number | null, int_page_from_hist_msg_read_user: number | null, int_page_from_hist_msg_read_count: number | null, int_page_from_feed_read_user: number | null, int_page_from_feed_read_count: number | null, int_page_from_friends_read_user: number | null, int_page_from_friends_read_count: number | null, int_page_from_other_read_user: number | null, int_page_from_other_read_count: number | null, feed_share_from_session_user: number | null, feed_share_from_session_count: number | null, feed_share_from_feed_user: number, feed_share_from_feed_count: number | null, feed_share_from_other_user: number | null, feed_share_from_other_count: number | null, article_id: number | null })[] }` Successfully retrieved broadcast stat
   */
  accountAnalyticBroadcastDetail = (
    { orgId, accId, ...query }: AccountAnalyticBroadcastDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          account_id: number;
          broadcast_id: number | null;
          broadcast_date: string;
          broadcast_date_i: number;
          latest_stat_date_i: number;
          wx_msgid: string;
          target_user: number | null;
          int_page_read_user: number;
          int_page_read_count: number;
          ori_page_read_user: number;
          ori_page_read_count: number;
          share_user: number;
          share_count: number;
          add_to_fav_user: number;
          add_to_fav_count: number;
          int_page_from_session_read_user: number | null;
          int_page_from_session_read_count: number | null;
          int_page_from_hist_msg_read_user: number | null;
          int_page_from_hist_msg_read_count: number | null;
          int_page_from_feed_read_user: number | null;
          int_page_from_feed_read_count: number | null;
          int_page_from_friends_read_user: number | null;
          int_page_from_friends_read_count: number | null;
          int_page_from_other_read_user: number | null;
          int_page_from_other_read_count: number | null;
          feed_share_from_session_user: number | null;
          feed_share_from_session_count: number | null;
          feed_share_from_feed_user: number;
          feed_share_from_feed_count: number | null;
          feed_share_from_other_user: number | null;
          feed_share_from_other_count: number | null;
          article_id: number | null;
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/broadcast`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticBroadcastDetail2
   * @summary Show broadcast stat
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/broadcast/{wx_msgid}
   * @originalName accountAnalyticBroadcastDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: ((object & { id?: number, account_id?: number, date?: string, date_i?: number, broadcast_date?: string, broadcast_date_i?: number, wx_msgid?: string, target_user?: number | null, title?: string, sequence?: number, int_page_read_user?: number, int_page_read_count?: number, ori_page_read_user?: number, ori_page_read_count?: number, share_user?: number, share_count?: number, add_to_fav_user?: number, add_to_fav_count?: number, int_page_from_session_read_user?: number | null, int_page_from_session_read_count?: number | null, int_page_from_hist_msg_read_user?: number | null, int_page_from_hist_msg_read_count?: number | null, int_page_from_feed_read_user?: number | null, int_page_from_feed_read_count?: number | null, int_page_from_friends_read_user?: number | null, int_page_from_friends_read_count?: number | null, int_page_from_other_read_user?: number | null, int_page_from_other_read_count?: number | null, feed_share_from_session_user?: number | null, feed_share_from_session_count?: number | null, feed_share_from_feed_user?: number, feed_share_from_feed_count?: number | null, feed_share_from_other_user?: number | null, feed_share_from_other_count?: number | null, article_id?: number | null } & { broadcast_id?: number | null, broadcast_articles_stat?: { id: number, account_id: number, date: string, date_i: number, broadcast_date: string, broadcast_date_i: number, wx_msgid: string, target_user: number | null, title: string, sequence: number, int_page_read_user: number, int_page_read_count: number, ori_page_read_user: number, ori_page_read_count: number, share_user: number, share_count: number, add_to_fav_user: number, add_to_fav_count: number, int_page_from_session_read_user: number | null, int_page_from_session_read_count: number | null, int_page_from_hist_msg_read_user: number | null, int_page_from_hist_msg_read_count: number | null, int_page_from_feed_read_user: number | null, int_page_from_feed_read_count: number | null, int_page_from_friends_read_user: number | null, int_page_from_friends_read_count: number | null, int_page_from_other_read_user: number | null, int_page_from_other_read_count: number | null, feed_share_from_session_user: number | null, feed_share_from_session_count: number | null, feed_share_from_feed_user: number, feed_share_from_feed_count: number | null, feed_share_from_other_user: number | null, feed_share_from_other_count: number | null, article_id: number | null } }))[] }` Successfully retrieved broadcast stat
   */
  accountAnalyticBroadcastDetail2 = (orgId: number, accId: number, wxMsgid: string, params: RequestParams = {}) =>
    this.request<
      {
        data: (object & {
          id?: number;
          account_id?: number;
          date?: string;
          date_i?: number;
          broadcast_date?: string;
          broadcast_date_i?: number;
          wx_msgid?: string;
          target_user?: number | null;
          title?: string;
          sequence?: number;
          int_page_read_user?: number;
          int_page_read_count?: number;
          ori_page_read_user?: number;
          ori_page_read_count?: number;
          share_user?: number;
          share_count?: number;
          add_to_fav_user?: number;
          add_to_fav_count?: number;
          int_page_from_session_read_user?: number | null;
          int_page_from_session_read_count?: number | null;
          int_page_from_hist_msg_read_user?: number | null;
          int_page_from_hist_msg_read_count?: number | null;
          int_page_from_feed_read_user?: number | null;
          int_page_from_feed_read_count?: number | null;
          int_page_from_friends_read_user?: number | null;
          int_page_from_friends_read_count?: number | null;
          int_page_from_other_read_user?: number | null;
          int_page_from_other_read_count?: number | null;
          feed_share_from_session_user?: number | null;
          feed_share_from_session_count?: number | null;
          feed_share_from_feed_user?: number;
          feed_share_from_feed_count?: number | null;
          feed_share_from_other_user?: number | null;
          feed_share_from_other_count?: number | null;
          article_id?: number | null;
        } & {
          broadcast_id?: number | null;
          broadcast_articles_stat?: {
            id: number;
            account_id: number;
            date: string;
            date_i: number;
            broadcast_date: string;
            broadcast_date_i: number;
            wx_msgid: string;
            target_user: number | null;
            title: string;
            sequence: number;
            int_page_read_user: number;
            int_page_read_count: number;
            ori_page_read_user: number;
            ori_page_read_count: number;
            share_user: number;
            share_count: number;
            add_to_fav_user: number;
            add_to_fav_count: number;
            int_page_from_session_read_user: number | null;
            int_page_from_session_read_count: number | null;
            int_page_from_hist_msg_read_user: number | null;
            int_page_from_hist_msg_read_count: number | null;
            int_page_from_feed_read_user: number | null;
            int_page_from_feed_read_count: number | null;
            int_page_from_friends_read_user: number | null;
            int_page_from_friends_read_count: number | null;
            int_page_from_other_read_user: number | null;
            int_page_from_other_read_count: number | null;
            feed_share_from_session_user: number | null;
            feed_share_from_session_count: number | null;
            feed_share_from_feed_user: number;
            feed_share_from_feed_count: number | null;
            feed_share_from_other_user: number | null;
            feed_share_from_other_count: number | null;
            article_id: number | null;
          };
        })[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/broadcast/${wxMsgid}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticBroadcastReportDetail
   * @summary Export broadcast report as csv file
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/broadcast/report
   * @secure
   * @response `200` `void` Return the output CSV file
   */
  accountAnalyticBroadcastReportDetail = (
    { orgId, accId, ...query }: AccountAnalyticBroadcastReportDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/analytic/broadcast/report`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticFollowerDateDetail
   * @summary Show follower stat by dates
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/follower/date
   * @secure
   * @response `200` `{ total_follower: number, gender_dist: object, lang_dist: object, geo_dist_cn_province: object, geo_dist_cn_city: object }` Successfully retrieved follower stat by dates
   */
  accountAnalyticFollowerDateDetail = (
    { orgId, accId, ...query }: AccountAnalyticFollowerDateDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        total_follower: number;
        gender_dist: object;
        lang_dist: object;
        geo_dist_cn_province: object;
        geo_dist_cn_city: object;
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/follower/date`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticFollowerRangeDetail
   * @summary Show follower daily stat by dates
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/follower/range
   * @secure
   * @response `200` `{ daily_counts: ({ id: number, date_i: number, cumulate: number })[], daily_growths: ({ id: number, date_i: number, new: number, cancel: number, net: number })[] }` Successfully retrieved follower daily stat by dates
   */
  accountAnalyticFollowerRangeDetail = (
    { orgId, accId, ...query }: AccountAnalyticFollowerRangeDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        daily_counts: { id: number; date_i: number; cumulate: number }[];
        daily_growths: { id: number; date_i: number; new: number; cancel: number; net: number }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/follower/range`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticMenuDetail
   * @summary Display a list of menu stats
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/menu
   * @secure
   * @response `200` `{ daily_stats: ({ id: number, date_i: number, total_count: number, unique_count: number })[], first_lvl_stats: ({ id: number, menu_item_id: number | null, total_count: number, unique_count: number, name: string | null, value: string | null, sequence: number, menu_hist_id: number, semantic_version: string })[], second_lvl_stats: ({ id: number, total_count: number, unique_count: number, item_id: number, item_name: string | null, item_value: string | null, item_sequence: number, parent_id: number, parent_name: string, parent_value: string, parent_sequence: number, menu_hist_id: number, semantic_version: string })[] }` Successfully retrieved a list of menu stats
   */
  accountAnalyticMenuDetail = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<
      {
        daily_stats: { id: number; date_i: number; total_count: number; unique_count: number }[];
        first_lvl_stats: {
          id: number;
          menu_item_id: number | null;
          total_count: number;
          unique_count: number;
          name: string | null;
          value: string | null;
          sequence: number;
          menu_hist_id: number;
          semantic_version: string;
        }[];
        second_lvl_stats: {
          id: number;
          total_count: number;
          unique_count: number;
          item_id: number;
          item_name: string | null;
          item_value: string | null;
          item_sequence: number;
          parent_id: number;
          parent_name: string;
          parent_value: string;
          parent_sequence: number;
          menu_hist_id: number;
          semantic_version: string;
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/menu`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticMessageDetail
   * @summary Display a list of message stats
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/message
   * @secure
   * @response `200` `{ daily_stats: ({ id: number, date_i: number, msg_count: number, user_count: number })[], top_hitted_rules: ({ id: number, auto_reply_id: number | null, name: string, msg_count: number, user_count: number })[], top_keywords: ({ id: number, auto_reply_id: number, auto_reply_name: string, keyword: string | null, msg_count: number, user_count: number })[], user_msg_count_ranges: ({ id: number, range: number, range_min: number, range_max: number, user_count: number, percentage: number })[] }` Successfully retrieved a list of message stats
   */
  accountAnalyticMessageDetail = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<
      {
        daily_stats: { id: number; date_i: number; msg_count: number; user_count: number }[];
        top_hitted_rules: {
          id: number;
          auto_reply_id: number | null;
          name: string;
          msg_count: number;
          user_count: number;
        }[];
        top_keywords: {
          id: number;
          auto_reply_id: number;
          auto_reply_name: string;
          keyword: string | null;
          msg_count: number;
          user_count: number;
        }[];
        user_msg_count_ranges: {
          id: number;
          range: number;
          range_min: number;
          range_max: number;
          user_count: number;
          percentage: number;
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/message`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Dashboard
   * @name AccountAnalyticOverviewDetail
   * @summary Return overview stats
   * @request GET:/org/{org_id}/account/{acc_id}/analytic/overview
   * @secure
   * @response `200` `{ last_broadcast_stats: { account_id: number, broadcast_id: number | null, broadcast_date: string, broadcast_date_i: number, latest_stat_date_i: number, wx_msgid: string, target_user: number | null, int_page_read_user: number, int_page_read_count: number, ori_page_read_user: number, ori_page_read_count: number, share_user: number, share_count: number, add_to_fav_user: number, add_to_fav_count: number, int_page_from_session_read_user: number | null, int_page_from_session_read_count: number | null, int_page_from_hist_msg_read_user: number | null, int_page_from_hist_msg_read_count: number | null, int_page_from_feed_read_user: number | null, int_page_from_feed_read_count: number | null, int_page_from_friends_read_user: number | null, int_page_from_friends_read_count: number | null, int_page_from_other_read_user: number | null, int_page_from_other_read_count: number | null, feed_share_from_session_user: number | null, feed_share_from_session_count: number | null, feed_share_from_feed_user: number, feed_share_from_feed_count: number | null, feed_share_from_other_user: number | null, feed_share_from_other_count: number | null, article_id: number | null }, follower_stats: { total: number, new: number, lost: number } }` Successfully retrieved overview stats
   */
  accountAnalyticOverviewDetail = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<
      {
        last_broadcast_stats: {
          account_id: number;
          broadcast_id: number | null;
          broadcast_date: string;
          broadcast_date_i: number;
          latest_stat_date_i: number;
          wx_msgid: string;
          target_user: number | null;
          int_page_read_user: number;
          int_page_read_count: number;
          ori_page_read_user: number;
          ori_page_read_count: number;
          share_user: number;
          share_count: number;
          add_to_fav_user: number;
          add_to_fav_count: number;
          int_page_from_session_read_user: number | null;
          int_page_from_session_read_count: number | null;
          int_page_from_hist_msg_read_user: number | null;
          int_page_from_hist_msg_read_count: number | null;
          int_page_from_feed_read_user: number | null;
          int_page_from_feed_read_count: number | null;
          int_page_from_friends_read_user: number | null;
          int_page_from_friends_read_count: number | null;
          int_page_from_other_read_user: number | null;
          int_page_from_other_read_count: number | null;
          feed_share_from_session_user: number | null;
          feed_share_from_session_count: number | null;
          feed_share_from_feed_user: number;
          feed_share_from_feed_count: number | null;
          feed_share_from_other_user: number | null;
          feed_share_from_other_count: number | null;
          article_id: number | null;
        };
        follower_stats: { total: number; new: number; lost: number };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/analytic/overview`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialDetail
   * @summary List materials under specified account
   * @request GET:/org/{org_id}/account/{acc_id}/material
   * @secure
   * @response `200` `{ data: ({ id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retrieved a list of materials
   */
  accountMaterialDetail = ({ orgId, accId, ...query }: AccountMaterialDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          group_id: number | null;
          file_name: string;
          display_name: string;
          cloud_storage_object_id: string;
          cloud_storage_object_params: string | null;
          cloud_storage_url: string;
          wx_media_type: "video" | "voice" | "image";
          wx_media_id: string;
          video_title: string | null;
          video_description: string | null;
          wxapi_uploaded_at: number;
          created_at: number;
          updated_at: number | null;
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/material`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialCreate
   * @summary Create material based on provided parameters
   * @request POST:/org/{org_id}/account/{acc_id}/material
   * @secure
   * @response `200` `{ data: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null } }` Successfully created material
   */
  accountMaterialCreate = (
    orgId: number,
    accId: number,
    data: AccountMaterialCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          group_id: number | null;
          file_name: string;
          display_name: string;
          cloud_storage_object_id: string;
          cloud_storage_object_params: string | null;
          cloud_storage_url: string;
          wx_media_type: "video" | "voice" | "image";
          wx_media_id: string;
          video_title: string | null;
          video_description: string | null;
          wxapi_uploaded_at: number;
          created_at: number;
          updated_at: number | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/material`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialDetail2
   * @summary Show material by ID
   * @request GET:/org/{org_id}/account/{acc_id}/material/{material}
   * @originalName accountMaterialDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null } }` Successfully retrieved details of the material
   */
  accountMaterialDetail2 = (orgId: number, accId: number, material: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          group_id: number | null;
          file_name: string;
          display_name: string;
          cloud_storage_object_id: string;
          cloud_storage_object_params: string | null;
          cloud_storage_url: string;
          wx_media_type: "video" | "voice" | "image";
          wx_media_id: string;
          video_title: string | null;
          video_description: string | null;
          wxapi_uploaded_at: number;
          created_at: number;
          updated_at: number | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/material/${material}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialPartialUpdate
   * @summary Update material by ID
   * @request PATCH:/org/{org_id}/account/{acc_id}/material/{material}
   * @secure
   * @response `200` `{ data: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null } }` Successfully updated the material and get the updated material as result
   */
  accountMaterialPartialUpdate = (
    orgId: number,
    accId: number,
    material: number,
    data: AccountMaterialPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          group_id: number | null;
          file_name: string;
          display_name: string;
          cloud_storage_object_id: string;
          cloud_storage_object_params: string | null;
          cloud_storage_url: string;
          wx_media_type: "video" | "voice" | "image";
          wx_media_id: string;
          video_title: string | null;
          video_description: string | null;
          wxapi_uploaded_at: number;
          created_at: number;
          updated_at: number | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/material/${material}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialDelete
   * @summary Delete material by ID
   * @request DELETE:/org/{org_id}/account/{acc_id}/material/{material}
   * @secure
   * @response `200` `{ id: number }` Successfully deleted the material and return its ID
   */
  accountMaterialDelete = (orgId: number, accId: number, material: number, params: RequestParams = {}) =>
    this.request<{ id: number }, any>({
      path: `/org/${orgId}/account/${accId}/material/${material}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialGroupDetail
   * @summary List material groups under specified account
   * @request GET:/org/{org_id}/account/{acc_id}/material-group
   * @secure
   * @response `200` `{ data: ({ id: number, name: string, created_at: number | null, updated_at: number | null })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retrieved a list of material groups
   */
  accountMaterialGroupDetail = (
    { orgId, accId, ...query }: AccountMaterialGroupDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: { id: number; name: string; created_at: number | null; updated_at: number | null }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/material-group`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialGroupCreate
   * @summary Create material group based on provided parameters
   * @request POST:/org/{org_id}/account/{acc_id}/material-group
   * @secure
   * @response `200` `{ data: ({ id: number, name: string, created_at: number | null, updated_at: number | null })[] }` Successfully created a material group
   */
  accountMaterialGroupCreate = (
    orgId: number,
    accId: number,
    data: AccountMaterialGroupCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<{ data: { id: number; name: string; created_at: number | null; updated_at: number | null }[] }, any>({
      path: `/org/${orgId}/account/${accId}/material-group`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialGroupDetail2
   * @summary Retrieve material group by ID
   * @request GET:/org/{org_id}/account/{acc_id}/material-group/{material_group}
   * @originalName accountMaterialGroupDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: ({ id: number, name: string, created_at: number | null, updated_at: number | null })[] }` Successfully retrieve the material group details
   */
  accountMaterialGroupDetail2 = (orgId: number, accId: number, materialGroup: number, params: RequestParams = {}) =>
    this.request<{ data: { id: number; name: string; created_at: number | null; updated_at: number | null }[] }, any>({
      path: `/org/${orgId}/account/${accId}/material-group/${materialGroup}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialGroupPartialUpdate
   * @summary Update material group by ID
   * @request PATCH:/org/{org_id}/account/{acc_id}/material-group/{material_group}
   * @secure
   * @response `200` `{ data: ({ id: number, name: string, created_at: number | null, updated_at: number | null })[] }` Successfully updated material group
   */
  accountMaterialGroupPartialUpdate = (
    orgId: number,
    accId: number,
    materialGroup: number,
    data: AccountMaterialGroupPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<{ data: { id: number; name: string; created_at: number | null; updated_at: number | null }[] }, any>({
      path: `/org/${orgId}/account/${accId}/material-group/${materialGroup}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Material
   * @name AccountMaterialGroupDelete
   * @summary Delete material group by ID
   * @request DELETE:/org/{org_id}/account/{acc_id}/material-group/{material_group}
   * @secure
   * @response `200` `{ id: number }` Successfully deleted the material group and get the ID as result
   */
  accountMaterialGroupDelete = (orgId: number, accId: number, materialGroup: number, params: RequestParams = {}) =>
    this.request<{ id: number }, any>({
      path: `/org/${orgId}/account/${accId}/material-group/${materialGroup}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Article Group
   * @name AccountArticleGroupDetail
   * @summary List articles under specified account
   * @request GET:/org/{org_id}/account/{acc_id}/article-group
   * @secure
   * @response `200` `{ data: ({ id: number, media_id: string, status: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retreive a list of article groups
   */
  accountArticleGroupDetail = (
    { orgId, accId, ...query }: AccountArticleGroupDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          media_id: string;
          status:
            | "DRAFT"
            | "PUBLISHED"
            | "Publish failed, WeChat blocked all articles access"
            | "Publish failed"
            | "Rejected by WeChat"
            | "Publishing, Pending for WeChat approval"
            | "WeChat rejected. Reason: Not original content."
            | "All article deleted by user.";
          articles: {
            id: number;
            title: string;
            digest: string | null;
            author: string | null;
            content: string;
            thumb_material_id: number | null;
            thumb_material: {
              id: number;
              group_id: number | null;
              file_name: string;
              display_name: string;
              cloud_storage_object_id: string;
              cloud_storage_object_params: string | null;
              cloud_storage_url: string;
              wx_media_type: "video" | "voice" | "image";
              wx_media_id: string;
              video_title: string | null;
              video_description: string | null;
              wxapi_uploaded_at: number;
              created_at: number;
              updated_at: number | null;
            };
            url: string | null;
            thumb_url: string;
            content_source_url: string | null;
            need_open_comment: boolean;
            only_fans_can_comment: boolean;
            create_time: number;
            update_time: number | null;
          }[];
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/article-group`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Article Group
   * @name AccountArticleGroupCreate
   * @summary Create an article based on the provided parameters
   * @request POST:/org/{org_id}/account/{acc_id}/article-group
   * @secure
   * @response `200` `void` Successfully created article
   */
  accountArticleGroupCreate = (
    orgId: number,
    accId: number,
    data: AccountArticleGroupCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/article-group`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Article Group
   * @name AccountArticleGroupDetail2
   * @summary Retrieve an article group by ID
   * @request GET:/org/{org_id}/account/{acc_id}/article-group/{article_group_id}
   * @originalName accountArticleGroupDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, media_id: string, status: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }` Successfully retrieved article group
   */
  accountArticleGroupDetail2 = (orgId: number, accId: number, articleGroupId: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          media_id: string;
          status:
            | "DRAFT"
            | "PUBLISHED"
            | "Publish failed, WeChat blocked all articles access"
            | "Publish failed"
            | "Rejected by WeChat"
            | "Publishing, Pending for WeChat approval"
            | "WeChat rejected. Reason: Not original content."
            | "All article deleted by user.";
          articles: {
            id: number;
            title: string;
            digest: string | null;
            author: string | null;
            content: string;
            thumb_material_id: number | null;
            thumb_material: {
              id: number;
              group_id: number | null;
              file_name: string;
              display_name: string;
              cloud_storage_object_id: string;
              cloud_storage_object_params: string | null;
              cloud_storage_url: string;
              wx_media_type: "video" | "voice" | "image";
              wx_media_id: string;
              video_title: string | null;
              video_description: string | null;
              wxapi_uploaded_at: number;
              created_at: number;
              updated_at: number | null;
            };
            url: string | null;
            thumb_url: string;
            content_source_url: string | null;
            need_open_comment: boolean;
            only_fans_can_comment: boolean;
            create_time: number;
            update_time: number | null;
          }[];
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/article-group/${articleGroupId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Article Group
   * @name AccountArticleGroupDelete
   * @summary Delete an article by ID
   * @request DELETE:/org/{org_id}/account/{acc_id}/article-group/{article_group_id}
   * @secure
   * @response `200` `void` Successfully deleted article and get the ID as result
   */
  accountArticleGroupDelete = (orgId: number, accId: number, articleGroupId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/article-group/${articleGroupId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Article Group
   * @name AccountArticleGroupPublishCreate
   * @summary Submit a draft article to wechat for publishing
   * @request POST:/org/{org_id}/account/{acc_id}/article-group/{article_group_id}/publish
   * @secure
   * @response `200` `void` Successfully retrieved article
   */
  accountArticleGroupPublishCreate = (
    orgId: number,
    accId: number,
    articleGroupId: number,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/article-group/${articleGroupId}/publish`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Article Group
   * @name AccountArticleGroupArticleUpdate
   * @summary Update article in article group by article ID and article group id
   * @request PUT:/org/{org_id}/account/{acc_id}/article-group/{article_group_id}/article/{article_id}
   * @secure
   * @response `200` `void` Successfully updated article
   */
  accountArticleGroupArticleUpdate = (
    orgId: number,
    accId: number,
    articleGroupId: number,
    articleId: number,
    data: AccountArticleGroupArticleUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/article-group/${articleGroupId}/article/${articleId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AccountMessageDetail
   * @summary List all messages under specified account
   * @request GET:/org/{org_id}/account/{acc_id}/message
   * @secure
   * @response `200` `{ data: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retrieve a list of messages
   */
  accountMessageDetail = ({ orgId, accId, ...query }: AccountMessageDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
          created_at: number | null;
          messageable: {
            text_content?: string | null;
            title?: string | null;
            description?: string | null;
            material_id?: number | null;
            thumb_material_id?: number | null;
            article_group_id?: number | null;
          } & {
            material?: {
              id: number;
              group_id: number | null;
              file_name: string;
              display_name: string;
              cloud_storage_object_id: string;
              cloud_storage_object_params: string | null;
              cloud_storage_url: string;
              wx_media_type: "video" | "voice" | "image";
              wx_media_id: string;
              video_title: string | null;
              video_description: string | null;
              wxapi_uploaded_at?: number;
              created_at: number;
              updated_at: number | null;
            };
            thumb_material?: {
              id: number;
              group_id: number | null;
              file_name: string;
              display_name: string;
              cloud_storage_object_id: string;
              cloud_storage_object_params: string | null;
              cloud_storage_url: string;
              wx_media_type: "video" | "voice" | "image";
              wx_media_id: string;
              video_title: string | null;
              video_description: string | null;
              wxapi_uploaded_at?: number;
              created_at: number;
              updated_at: number | null;
            };
            article_group?: {
              id?: number;
              media_id?: string;
              status?:
                | "DRAFT"
                | "PUBLISHED"
                | "Publish failed, WeChat blocked all articles access"
                | "Publish failed"
                | "Rejected by WeChat"
                | "Publishing, Pending for WeChat approval"
                | "WeChat rejected. Reason: Not original content."
                | "All article deleted by user.";
              articles?: {
                id: number;
                title: string;
                digest: string | null;
                author: string | null;
                content: string;
                thumb_material_id: number | null;
                thumb_material: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                url: string | null;
                thumb_url: string;
                content_source_url: string | null;
                need_open_comment: boolean;
                only_fans_can_comment: boolean;
                create_time: number;
                update_time: number | null;
              }[];
            };
          };
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/message`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AccountMessageDetail2
   * @summary Retrieve a message by ID
   * @request GET:/org/{org_id}/account/{acc_id}/message/{message}
   * @originalName accountMessageDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }` Successfully retrieved the message details
   */
  accountMessageDetail2 = (orgId: number, accId: number, message: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
          created_at: number | null;
          messageable: {
            text_content?: string | null;
            title?: string | null;
            description?: string | null;
            material_id?: number | null;
            thumb_material_id?: number | null;
            article_group_id?: number | null;
          } & {
            material?: {
              id: number;
              group_id: number | null;
              file_name: string;
              display_name: string;
              cloud_storage_object_id: string;
              cloud_storage_object_params: string | null;
              cloud_storage_url: string;
              wx_media_type: "video" | "voice" | "image";
              wx_media_id: string;
              video_title: string | null;
              video_description: string | null;
              wxapi_uploaded_at?: number;
              created_at: number;
              updated_at: number | null;
            };
            thumb_material?: {
              id: number;
              group_id: number | null;
              file_name: string;
              display_name: string;
              cloud_storage_object_id: string;
              cloud_storage_object_params: string | null;
              cloud_storage_url: string;
              wx_media_type: "video" | "voice" | "image";
              wx_media_id: string;
              video_title: string | null;
              video_description: string | null;
              wxapi_uploaded_at?: number;
              created_at: number;
              updated_at: number | null;
            };
            article_group?: {
              id?: number;
              media_id?: string;
              status?:
                | "DRAFT"
                | "PUBLISHED"
                | "Publish failed, WeChat blocked all articles access"
                | "Publish failed"
                | "Rejected by WeChat"
                | "Publishing, Pending for WeChat approval"
                | "WeChat rejected. Reason: Not original content."
                | "All article deleted by user.";
              articles?: {
                id: number;
                title: string;
                digest: string | null;
                author: string | null;
                content: string;
                thumb_material_id: number | null;
                thumb_material: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                url: string | null;
                thumb_url: string;
                content_source_url: string | null;
                need_open_comment: boolean;
                only_fans_can_comment: boolean;
                create_time: number;
                update_time: number | null;
              }[];
            };
          };
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/message/${message}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AccountConversationDetail
   * @summary Show conversation of a follower, excluding events
   * @request GET:/org/{org_id}/account/{acc_id}/conversation/{follower_id}
   * @secure
   * @response `200` `{ data: (Record<string, { id: string, app_id: string, wx_msg_ts: number, wx_msg_id: string, wx_msg_type: string, wx_event_type: string | null, wx_event_key: string | null, wx_ticket: string | null, wx_content: string | null, media_pic_url: string | null, media_format: string | null, media_recognition: string | null, location_lat: number | null, location_lng: number | null, location_precision: number | null, location_scale: number | null, location_label: string | null, link_title: string | null, link_description: string | null, link_url: string | null, media_url: string | null, thumb_url: string | null, type: "INCOMING_MESSAGE" | "OUTGOING_MESSAGE" | "INBOX", auto_reply_id: number | null, reply_msg_ids: (number)[] | null, menu_item_id: number | null, store_ids: (number)[] | null, time_cost: number, reply_msg_ts: number | null, reply_msg_id: number | null, auto_reply: { id: number, qrcode_id: number | null, messages: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], materials: ({ id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null })[], tag: { id: number, name: string }, qrcode: { id: number, url: string | null, image_url: string | null, type: string, expiry_time: number | null, ticket: string | null, is_in_use: boolean | null }, name: string, status: "ACTIVE" | "PAUSE", started_at: number | null, ended_at: number | null, keywords: (string)[], type: "KEYWORD_EXACT" | "KEYWORD_PHRASE" | "SUBSCRIBE" | "DEFAULT" | "QRCODE" | "LOCATION" | "IMAGE" | "VOICE" | "VIDEO", action_type: "reply_single_message" | "reply_all_messages", action_params: object | null }, messages: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], message: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) } }>)[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retrieved a list of conversation
   */
  accountConversationDetail = (
    { orgId, accId, followerId, ...query }: AccountConversationDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: Record<
          string,
          {
            id: string;
            app_id: string;
            wx_msg_ts: number;
            wx_msg_id: string;
            wx_msg_type: string;
            wx_event_type: string | null;
            wx_event_key: string | null;
            wx_ticket: string | null;
            wx_content: string | null;
            media_pic_url: string | null;
            media_format: string | null;
            media_recognition: string | null;
            location_lat: number | null;
            location_lng: number | null;
            location_precision: number | null;
            location_scale: number | null;
            location_label: string | null;
            link_title: string | null;
            link_description: string | null;
            link_url: string | null;
            media_url: string | null;
            thumb_url: string | null;
            type: "INCOMING_MESSAGE" | "OUTGOING_MESSAGE" | "INBOX";
            auto_reply_id: number | null;
            reply_msg_ids: number[] | null;
            menu_item_id: number | null;
            store_ids: number[] | null;
            time_cost: number;
            reply_msg_ts: number | null;
            reply_msg_id: number | null;
            auto_reply: {
              id: number;
              qrcode_id: number | null;
              messages: {
                id: number;
                message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
                created_at: number | null;
                messageable: {
                  text_content?: string | null;
                  title?: string | null;
                  description?: string | null;
                  material_id?: number | null;
                  thumb_material_id?: number | null;
                  article_group_id?: number | null;
                } & {
                  material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  thumb_material?: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  article_group?: {
                    id?: number;
                    media_id?: string;
                    status?:
                      | "DRAFT"
                      | "PUBLISHED"
                      | "Publish failed, WeChat blocked all articles access"
                      | "Publish failed"
                      | "Rejected by WeChat"
                      | "Publishing, Pending for WeChat approval"
                      | "WeChat rejected. Reason: Not original content."
                      | "All article deleted by user.";
                    articles?: {
                      id: number;
                      title: string;
                      digest: string | null;
                      author: string | null;
                      content: string;
                      thumb_material_id: number | null;
                      thumb_material: {
                        id: number;
                        group_id: number | null;
                        file_name: string;
                        display_name: string;
                        cloud_storage_object_id: string;
                        cloud_storage_object_params: string | null;
                        cloud_storage_url: string;
                        wx_media_type: "video" | "voice" | "image";
                        wx_media_id: string;
                        video_title: string | null;
                        video_description: string | null;
                        wxapi_uploaded_at?: number;
                        created_at: number;
                        updated_at: number | null;
                      };
                      url: string | null;
                      thumb_url: string;
                      content_source_url: string | null;
                      need_open_comment: boolean;
                      only_fans_can_comment: boolean;
                      create_time: number;
                      update_time: number | null;
                    }[];
                  };
                };
              }[];
              materials: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at: number;
                created_at: number;
                updated_at: number | null;
              }[];
              tag: { id: number; name: string };
              qrcode: {
                id: number;
                url: string | null;
                image_url: string | null;
                type: string;
                expiry_time: number | null;
                ticket: string | null;
                is_in_use: boolean | null;
              };
              name: string;
              status: "ACTIVE" | "PAUSE";
              started_at: number | null;
              ended_at: number | null;
              keywords: string[];
              type:
                | "KEYWORD_EXACT"
                | "KEYWORD_PHRASE"
                | "SUBSCRIBE"
                | "DEFAULT"
                | "QRCODE"
                | "LOCATION"
                | "IMAGE"
                | "VOICE"
                | "VIDEO";
              action_type: "reply_single_message" | "reply_all_messages";
              action_params: object | null;
            };
            messages: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            }[];
            message: {
              id: number;
              message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
              created_at: number | null;
              messageable: {
                text_content?: string | null;
                title?: string | null;
                description?: string | null;
                material_id?: number | null;
                thumb_material_id?: number | null;
                article_group_id?: number | null;
              } & {
                material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                thumb_material?: {
                  id: number;
                  group_id: number | null;
                  file_name: string;
                  display_name: string;
                  cloud_storage_object_id: string;
                  cloud_storage_object_params: string | null;
                  cloud_storage_url: string;
                  wx_media_type: "video" | "voice" | "image";
                  wx_media_id: string;
                  video_title: string | null;
                  video_description: string | null;
                  wxapi_uploaded_at?: number;
                  created_at: number;
                  updated_at: number | null;
                };
                article_group?: {
                  id?: number;
                  media_id?: string;
                  status?:
                    | "DRAFT"
                    | "PUBLISHED"
                    | "Publish failed, WeChat blocked all articles access"
                    | "Publish failed"
                    | "Rejected by WeChat"
                    | "Publishing, Pending for WeChat approval"
                    | "WeChat rejected. Reason: Not original content."
                    | "All article deleted by user.";
                  articles?: {
                    id: number;
                    title: string;
                    digest: string | null;
                    author: string | null;
                    content: string;
                    thumb_material_id: number | null;
                    thumb_material: {
                      id: number;
                      group_id: number | null;
                      file_name: string;
                      display_name: string;
                      cloud_storage_object_id: string;
                      cloud_storage_object_params: string | null;
                      cloud_storage_url: string;
                      wx_media_type: "video" | "voice" | "image";
                      wx_media_id: string;
                      video_title: string | null;
                      video_description: string | null;
                      wxapi_uploaded_at?: number;
                      created_at: number;
                      updated_at: number | null;
                    };
                    url: string | null;
                    thumb_url: string;
                    content_source_url: string | null;
                    need_open_comment: boolean;
                    only_fans_can_comment: boolean;
                    create_time: number;
                    update_time: number | null;
                  }[];
                };
              };
            };
          }
        >[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/conversation/${followerId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AccountInboxDetail
   * @summary Get all incoming messages of an account
   * @request GET:/org/{org_id}/account/{acc_id}/inbox
   * @secure
   * @response `200` `{ data: ({ id: number, wx_msg_ts: number, wx_msg_type: string, wx_content: string, link_url: string, reply_msg_id: number, follower_id: number, follower: { id: number, is_subscribed: boolean | null, open_id: string, union_id: string | null, geo_id: number | null, location: { wxgeo_id: number, parent_id: number | null, iso_num: string, "iso2": string, "iso3": string, name_en: string, name_zh_hans: string, name_zh_hant: string, fullname_en: string, fullname_zh_hans: string, fullname_zh_hant: string, path: string, admin_code: number | null, geoname_id: number | null, short_code: string | null, status: string, remark: string | null }, country: string | null, province: string | null, city: string | null, gender: "MALE" | "FEMALE" | "UNDEFINED" | null, nickname: string | null, remark: string | null, language: "zh_CN" | "zh_TW" | "en" | null, signature: string | null, image_path: string | null, subscribed_at: number | null, last_interaction: number | null, unsubscribed_at: number | null, is_blacklist: boolean | null, tag_ids: (number)[], tags: (({ id: number, name: string }))[] } })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully get a list of incoming messages
   */
  accountInboxDetail = ({ orgId, accId, ...query }: AccountInboxDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          wx_msg_ts: number;
          wx_msg_type: string;
          wx_content: string;
          link_url: string;
          reply_msg_id: number;
          follower_id: number;
          follower: {
            id: number;
            is_subscribed: boolean | null;
            open_id: string;
            union_id: string | null;
            geo_id: number | null;
            location: {
              wxgeo_id: number;
              parent_id: number | null;
              iso_num: string;
              iso2: string;
              iso3: string;
              name_en: string;
              name_zh_hans: string;
              name_zh_hant: string;
              fullname_en: string;
              fullname_zh_hans: string;
              fullname_zh_hant: string;
              path: string;
              admin_code: number | null;
              geoname_id: number | null;
              short_code: string | null;
              status: string;
              remark: string | null;
            };
            country: string | null;
            province: string | null;
            city: string | null;
            gender: "MALE" | "FEMALE" | "UNDEFINED" | null;
            nickname: string | null;
            remark: string | null;
            language: "zh_CN" | "zh_TW" | "en" | null;
            signature: string | null;
            image_path: string | null;
            subscribed_at: number | null;
            last_interaction: number | null;
            unsubscribed_at: number | null;
            is_blacklist: boolean | null;
            tag_ids: number[];
            tags: { id: number; name: string }[];
          };
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/inbox`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AccountInboxSendMessageCreate
   * @summary Send message reply to inbox message
   * @request POST:/org/{org_id}/account/{acc_id}/inbox/send-message
   * @secure
   * @response `200` `void` Successfully fired reply action
   */
  accountInboxSendMessageCreate = (
    orgId: number,
    accId: number,
    data: AccountInboxSendMessageCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/inbox/send-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Broadcast
   * @name AccountBroadcastDetail
   * @summary List broadcasts under specified account
   * @request GET:/org/{org_id}/account/{acc_id}/broadcast
   * @secure
   * @response `200` `{ data: ({ id: number, status: "UPLOADING" | "WAITING_FOR_CONFIRMATION" | "SCHEDULED" | "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED", target: "all" | "filter", condition: ({ tag_id: number })[] | null, tag: { id: number, name: string }, created_at: number, scheduled_at: number | null, updated_at: number | null, started_at: number | null, completed_at: number | null, cancelled_at: number | null, cancelled_by: string | null, result: { id: number, wx_msg_id: number | null, wx_total_count: number | null, wx_sent_count: number | null, wx_filter_count: number | null, wx_error_code: number | null, wx_error_msg: string | null, wx_error_count: number | null, wx_copyright_check_result: object | null, wx_msg_data_id: number | null }, message_id: number, message: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, wx_msg_id: number | null })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retrieved a list of broadcasts
   */
  accountBroadcastDetail = ({ orgId, accId, ...query }: AccountBroadcastDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status:
            | "UPLOADING"
            | "WAITING_FOR_CONFIRMATION"
            | "SCHEDULED"
            | "PENDING"
            | "PROCESSING"
            | "COMPLETED"
            | "FAILED"
            | "CANCELLED";
          target: "all" | "filter";
          condition: { tag_id: number }[] | null;
          tag: { id: number; name: string };
          created_at: number;
          scheduled_at: number | null;
          updated_at: number | null;
          started_at: number | null;
          completed_at: number | null;
          cancelled_at: number | null;
          cancelled_by: string | null;
          result: {
            id: number;
            wx_msg_id: number | null;
            wx_total_count: number | null;
            wx_sent_count: number | null;
            wx_filter_count: number | null;
            wx_error_code: number | null;
            wx_error_msg: string | null;
            wx_error_count: number | null;
            wx_copyright_check_result: object | null;
            wx_msg_data_id: number | null;
          };
          message_id: number;
          message: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          };
          wx_msg_id: number | null;
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/broadcast`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Broadcast
   * @name AccountBroadcastCreate
   * @summary Create broadcast with parameters provided
   * @request POST:/org/{org_id}/account/{acc_id}/broadcast
   * @secure
   * @response `200` `{ data: { id: number, status: "UPLOADING" | "WAITING_FOR_CONFIRMATION" | "SCHEDULED" | "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED", target: "all" | "filter", condition: ({ tag_id: number })[] | null, tag: { id: number, name: string }, created_at: number, scheduled_at: number | null, updated_at: number | null, started_at: number | null, completed_at: number | null, cancelled_at: number | null, cancelled_by: string | null, result: { id: number, wx_msg_id: number | null, wx_total_count: number | null, wx_sent_count: number | null, wx_filter_count: number | null, wx_error_code: number | null, wx_error_msg: string | null, wx_error_count: number | null, wx_copyright_check_result: object | null, wx_msg_data_id: number | null }, message_id: number, message: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, wx_msg_id: number | null } }` Successfully create broadcast
   */
  accountBroadcastCreate = (
    orgId: number,
    accId: number,
    data: AccountBroadcastCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          status:
            | "UPLOADING"
            | "WAITING_FOR_CONFIRMATION"
            | "SCHEDULED"
            | "PENDING"
            | "PROCESSING"
            | "COMPLETED"
            | "FAILED"
            | "CANCELLED";
          target: "all" | "filter";
          condition: { tag_id: number }[] | null;
          tag: { id: number; name: string };
          created_at: number;
          scheduled_at: number | null;
          updated_at: number | null;
          started_at: number | null;
          completed_at: number | null;
          cancelled_at: number | null;
          cancelled_by: string | null;
          result: {
            id: number;
            wx_msg_id: number | null;
            wx_total_count: number | null;
            wx_sent_count: number | null;
            wx_filter_count: number | null;
            wx_error_code: number | null;
            wx_error_msg: string | null;
            wx_error_count: number | null;
            wx_copyright_check_result: object | null;
            wx_msg_data_id: number | null;
          };
          message_id: number;
          message: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          };
          wx_msg_id: number | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/broadcast`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Broadcast
   * @name AccountBroadcastPreviewCreate
   * @summary Preview broadcast
   * @request POST:/org/{org_id}/account/{acc_id}/broadcast/preview
   * @secure
   * @response `200` `void` Successfully dispatched preview job
   */
  accountBroadcastPreviewCreate = (
    orgId: number,
    accId: number,
    data: AccountBroadcastPreviewCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/org/${orgId}/account/${accId}/broadcast/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Broadcast
   * @name AccountBroadcastDetail2
   * @summary Retrieve a broadcast by ID
   * @request GET:/org/{org_id}/account/{acc_id}/broadcast/{broadcast}
   * @originalName accountBroadcastDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, status: "UPLOADING" | "WAITING_FOR_CONFIRMATION" | "SCHEDULED" | "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED", target: "all" | "filter", condition: ({ tag_id: number })[] | null, tag: { id: number, name: string }, created_at: number, scheduled_at: number | null, updated_at: number | null, started_at: number | null, completed_at: number | null, cancelled_at: number | null, cancelled_by: string | null, result: { id: number, wx_msg_id: number | null, wx_total_count: number | null, wx_sent_count: number | null, wx_filter_count: number | null, wx_error_code: number | null, wx_error_msg: string | null, wx_error_count: number | null, wx_copyright_check_result: object | null, wx_msg_data_id: number | null }, message_id: number, message: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, wx_msg_id: number | null } }` Successfully retrieved the broadcast details
   */
  accountBroadcastDetail2 = (orgId: number, accId: number, broadcast: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          status:
            | "UPLOADING"
            | "WAITING_FOR_CONFIRMATION"
            | "SCHEDULED"
            | "PENDING"
            | "PROCESSING"
            | "COMPLETED"
            | "FAILED"
            | "CANCELLED";
          target: "all" | "filter";
          condition: { tag_id: number }[] | null;
          tag: { id: number; name: string };
          created_at: number;
          scheduled_at: number | null;
          updated_at: number | null;
          started_at: number | null;
          completed_at: number | null;
          cancelled_at: number | null;
          cancelled_by: string | null;
          result: {
            id: number;
            wx_msg_id: number | null;
            wx_total_count: number | null;
            wx_sent_count: number | null;
            wx_filter_count: number | null;
            wx_error_code: number | null;
            wx_error_msg: string | null;
            wx_error_count: number | null;
            wx_copyright_check_result: object | null;
            wx_msg_data_id: number | null;
          };
          message_id: number;
          message: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          };
          wx_msg_id: number | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/broadcast/${broadcast}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Broadcast
   * @name AccountBroadcastPartialUpdate
   * @summary Update a broadcast by ID
   * @request PATCH:/org/{org_id}/account/{acc_id}/broadcast/{broadcast}
   * @secure
   * @response `200` `{ data: { id: number, status: "UPLOADING" | "WAITING_FOR_CONFIRMATION" | "SCHEDULED" | "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED", target: "all" | "filter", condition: ({ tag_id: number })[] | null, tag: { id: number, name: string }, created_at: number, scheduled_at: number | null, updated_at: number | null, started_at: number | null, completed_at: number | null, cancelled_at: number | null, cancelled_by: string | null, result: { id: number, wx_msg_id: number | null, wx_total_count: number | null, wx_sent_count: number | null, wx_filter_count: number | null, wx_error_code: number | null, wx_error_msg: string | null, wx_error_count: number | null, wx_copyright_check_result: object | null, wx_msg_data_id: number | null }, message_id: number, message: { id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) }, wx_msg_id: number | null } }` Successfully updated the broadcast
   */
  accountBroadcastPartialUpdate = (
    orgId: number,
    accId: number,
    broadcast: number,
    data: AccountBroadcastPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          status:
            | "UPLOADING"
            | "WAITING_FOR_CONFIRMATION"
            | "SCHEDULED"
            | "PENDING"
            | "PROCESSING"
            | "COMPLETED"
            | "FAILED"
            | "CANCELLED";
          target: "all" | "filter";
          condition: { tag_id: number }[] | null;
          tag: { id: number; name: string };
          created_at: number;
          scheduled_at: number | null;
          updated_at: number | null;
          started_at: number | null;
          completed_at: number | null;
          cancelled_at: number | null;
          cancelled_by: string | null;
          result: {
            id: number;
            wx_msg_id: number | null;
            wx_total_count: number | null;
            wx_sent_count: number | null;
            wx_filter_count: number | null;
            wx_error_code: number | null;
            wx_error_msg: string | null;
            wx_error_count: number | null;
            wx_copyright_check_result: object | null;
            wx_msg_data_id: number | null;
          };
          message_id: number;
          message: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          };
          wx_msg_id: number | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/broadcast/${broadcast}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Broadcast
   * @name AccountBroadcastDelete
   * @summary Remove a broadcast by ID
   * @request DELETE:/org/{org_id}/account/{acc_id}/broadcast/{broadcast}
   * @secure
   * @response `200` `{ id: number }` Successfully removed the broadcast
   */
  accountBroadcastDelete = (orgId: number, accId: number, broadcast: number, params: RequestParams = {}) =>
    this.request<{ id: number }, any>({
      path: `/org/${orgId}/account/${accId}/broadcast/${broadcast}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auto Reply
   * @name AccountAutoReplyDetail
   * @summary List auto replies under specified account
   * @request GET:/org/{org_id}/account/{acc_id}/auto-reply
   * @secure
   * @response `200` `{ data: ({ id: number, qrcode_id: number | null, messages: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], materials: ({ id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null })[], tag: { id: number, name: string }, qrcode: { id: number, url: string | null, image_url: string | null, type: string, expiry_time: number | null, ticket: string | null, is_in_use: boolean | null }, name: string, status: "ACTIVE" | "PAUSE", started_at: number | null, ended_at: number | null, keywords: (string)[], type: "KEYWORD_EXACT" | "KEYWORD_PHRASE" | "SUBSCRIBE" | "DEFAULT" | "QRCODE" | "LOCATION" | "IMAGE" | "VOICE" | "VIDEO", action_type: "reply_single_message" | "reply_all_messages", action_params: object | null })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` List auto replies under specified account
   */
  accountAutoReplyDetail = ({ orgId, accId, ...query }: AccountAutoReplyDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          qrcode_id: number | null;
          messages: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          }[];
          materials: {
            id: number;
            group_id: number | null;
            file_name: string;
            display_name: string;
            cloud_storage_object_id: string;
            cloud_storage_object_params: string | null;
            cloud_storage_url: string;
            wx_media_type: "video" | "voice" | "image";
            wx_media_id: string;
            video_title: string | null;
            video_description: string | null;
            wxapi_uploaded_at: number;
            created_at: number;
            updated_at: number | null;
          }[];
          tag: { id: number; name: string };
          qrcode: {
            id: number;
            url: string | null;
            image_url: string | null;
            type: string;
            expiry_time: number | null;
            ticket: string | null;
            is_in_use: boolean | null;
          };
          name: string;
          status: "ACTIVE" | "PAUSE";
          started_at: number | null;
          ended_at: number | null;
          keywords: string[];
          type:
            | "KEYWORD_EXACT"
            | "KEYWORD_PHRASE"
            | "SUBSCRIBE"
            | "DEFAULT"
            | "QRCODE"
            | "LOCATION"
            | "IMAGE"
            | "VOICE"
            | "VIDEO";
          action_type: "reply_single_message" | "reply_all_messages";
          action_params: object | null;
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/auto-reply`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auto Reply
   * @name AccountAutoReplyCreate
   * @summary Create an auto reply
   * @request POST:/org/{org_id}/account/{acc_id}/auto-reply
   * @secure
   * @response `200` `{ data: { id: number, qrcode_id: number | null, messages: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], materials: ({ id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null })[], tag: { id: number, name: string }, qrcode: { id: number, url: string | null, image_url: string | null, type: string, expiry_time: number | null, ticket: string | null, is_in_use: boolean | null }, name: string, status: "ACTIVE" | "PAUSE", started_at: number | null, ended_at: number | null, keywords: (string)[], type: "KEYWORD_EXACT" | "KEYWORD_PHRASE" | "SUBSCRIBE" | "DEFAULT" | "QRCODE" | "LOCATION" | "IMAGE" | "VOICE" | "VIDEO", action_type: "reply_single_message" | "reply_all_messages", action_params: object | null } }` Successfully created auto reply
   */
  accountAutoReplyCreate = (
    orgId: number,
    accId: number,
    data: AccountAutoReplyCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          qrcode_id: number | null;
          messages: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          }[];
          materials: {
            id: number;
            group_id: number | null;
            file_name: string;
            display_name: string;
            cloud_storage_object_id: string;
            cloud_storage_object_params: string | null;
            cloud_storage_url: string;
            wx_media_type: "video" | "voice" | "image";
            wx_media_id: string;
            video_title: string | null;
            video_description: string | null;
            wxapi_uploaded_at: number;
            created_at: number;
            updated_at: number | null;
          }[];
          tag: { id: number; name: string };
          qrcode: {
            id: number;
            url: string | null;
            image_url: string | null;
            type: string;
            expiry_time: number | null;
            ticket: string | null;
            is_in_use: boolean | null;
          };
          name: string;
          status: "ACTIVE" | "PAUSE";
          started_at: number | null;
          ended_at: number | null;
          keywords: string[];
          type:
            | "KEYWORD_EXACT"
            | "KEYWORD_PHRASE"
            | "SUBSCRIBE"
            | "DEFAULT"
            | "QRCODE"
            | "LOCATION"
            | "IMAGE"
            | "VOICE"
            | "VIDEO";
          action_type: "reply_single_message" | "reply_all_messages";
          action_params: object | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/auto-reply`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auto Reply
   * @name AccountAutoReplyDetail2
   * @summary Show auto reply by ID
   * @request GET:/org/{org_id}/account/{acc_id}/auto-reply/{auto_reply}
   * @originalName accountAutoReplyDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, qrcode_id: number | null, messages: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], materials: ({ id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null })[], tag: { id: number, name: string }, qrcode: { id: number, url: string | null, image_url: string | null, type: string, expiry_time: number | null, ticket: string | null, is_in_use: boolean | null }, name: string, status: "ACTIVE" | "PAUSE", started_at: number | null, ended_at: number | null, keywords: (string)[], type: "KEYWORD_EXACT" | "KEYWORD_PHRASE" | "SUBSCRIBE" | "DEFAULT" | "QRCODE" | "LOCATION" | "IMAGE" | "VOICE" | "VIDEO", action_type: "reply_single_message" | "reply_all_messages", action_params: object | null } }` Successfully retrieved the auto reply details
   */
  accountAutoReplyDetail2 = (orgId: number, accId: number, autoReply: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          qrcode_id: number | null;
          messages: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          }[];
          materials: {
            id: number;
            group_id: number | null;
            file_name: string;
            display_name: string;
            cloud_storage_object_id: string;
            cloud_storage_object_params: string | null;
            cloud_storage_url: string;
            wx_media_type: "video" | "voice" | "image";
            wx_media_id: string;
            video_title: string | null;
            video_description: string | null;
            wxapi_uploaded_at: number;
            created_at: number;
            updated_at: number | null;
          }[];
          tag: { id: number; name: string };
          qrcode: {
            id: number;
            url: string | null;
            image_url: string | null;
            type: string;
            expiry_time: number | null;
            ticket: string | null;
            is_in_use: boolean | null;
          };
          name: string;
          status: "ACTIVE" | "PAUSE";
          started_at: number | null;
          ended_at: number | null;
          keywords: string[];
          type:
            | "KEYWORD_EXACT"
            | "KEYWORD_PHRASE"
            | "SUBSCRIBE"
            | "DEFAULT"
            | "QRCODE"
            | "LOCATION"
            | "IMAGE"
            | "VOICE"
            | "VIDEO";
          action_type: "reply_single_message" | "reply_all_messages";
          action_params: object | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/auto-reply/${autoReply}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auto Reply
   * @name AccountAutoReplyPartialUpdate
   * @summary Update an auto reply
   * @request PATCH:/org/{org_id}/account/{acc_id}/auto-reply/{auto_reply}
   * @secure
   * @response `200` `{ data: { id: number, qrcode_id: number | null, messages: ({ id: number, message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT", created_at: number | null, messageable: ({ text_content?: string | null, title?: string | null, description?: string | null, material_id?: number | null, thumb_material_id?: number | null, article_group_id?: number | null } & { material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, thumb_material?: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, article_group?: { id?: number, media_id?: string, status?: "DRAFT" | "PUBLISHED" | "Publish failed, WeChat blocked all articles access" | "Publish failed" | "Rejected by WeChat" | "Publishing, Pending for WeChat approval" | "WeChat rejected. Reason: Not original content." | "All article deleted by user.", articles?: ({ id: number, title: string, digest: string | null, author: string | null, content: string, thumb_material_id: number | null, thumb_material: { id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at?: number, created_at: number, updated_at: number | null }, url: string | null, thumb_url: string, content_source_url: string | null, need_open_comment: boolean, only_fans_can_comment: boolean, create_time: number, update_time: number | null })[] } }) })[], materials: ({ id: number, group_id: number | null, file_name: string, display_name: string, cloud_storage_object_id: string, cloud_storage_object_params: string | null, cloud_storage_url: string, wx_media_type: "video" | "voice" | "image", wx_media_id: string, video_title: string | null, video_description: string | null, wxapi_uploaded_at: number, created_at: number, updated_at: number | null })[], tag: { id: number, name: string }, qrcode: { id: number, url: string | null, image_url: string | null, type: string, expiry_time: number | null, ticket: string | null, is_in_use: boolean | null }, name: string, status: "ACTIVE" | "PAUSE", started_at: number | null, ended_at: number | null, keywords: (string)[], type: "KEYWORD_EXACT" | "KEYWORD_PHRASE" | "SUBSCRIBE" | "DEFAULT" | "QRCODE" | "LOCATION" | "IMAGE" | "VOICE" | "VIDEO", action_type: "reply_single_message" | "reply_all_messages", action_params: object | null } }` Successfully updated auto reply
   */
  accountAutoReplyPartialUpdate = (
    orgId: number,
    accId: number,
    autoReply: number,
    data: AccountAutoReplyPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          qrcode_id: number | null;
          messages: {
            id: number;
            message_type: "NEWS" | "IMAGE" | "VOICE" | "VIDEO" | "TEXT";
            created_at: number | null;
            messageable: {
              text_content?: string | null;
              title?: string | null;
              description?: string | null;
              material_id?: number | null;
              thumb_material_id?: number | null;
              article_group_id?: number | null;
            } & {
              material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              thumb_material?: {
                id: number;
                group_id: number | null;
                file_name: string;
                display_name: string;
                cloud_storage_object_id: string;
                cloud_storage_object_params: string | null;
                cloud_storage_url: string;
                wx_media_type: "video" | "voice" | "image";
                wx_media_id: string;
                video_title: string | null;
                video_description: string | null;
                wxapi_uploaded_at?: number;
                created_at: number;
                updated_at: number | null;
              };
              article_group?: {
                id?: number;
                media_id?: string;
                status?:
                  | "DRAFT"
                  | "PUBLISHED"
                  | "Publish failed, WeChat blocked all articles access"
                  | "Publish failed"
                  | "Rejected by WeChat"
                  | "Publishing, Pending for WeChat approval"
                  | "WeChat rejected. Reason: Not original content."
                  | "All article deleted by user.";
                articles?: {
                  id: number;
                  title: string;
                  digest: string | null;
                  author: string | null;
                  content: string;
                  thumb_material_id: number | null;
                  thumb_material: {
                    id: number;
                    group_id: number | null;
                    file_name: string;
                    display_name: string;
                    cloud_storage_object_id: string;
                    cloud_storage_object_params: string | null;
                    cloud_storage_url: string;
                    wx_media_type: "video" | "voice" | "image";
                    wx_media_id: string;
                    video_title: string | null;
                    video_description: string | null;
                    wxapi_uploaded_at?: number;
                    created_at: number;
                    updated_at: number | null;
                  };
                  url: string | null;
                  thumb_url: string;
                  content_source_url: string | null;
                  need_open_comment: boolean;
                  only_fans_can_comment: boolean;
                  create_time: number;
                  update_time: number | null;
                }[];
              };
            };
          }[];
          materials: {
            id: number;
            group_id: number | null;
            file_name: string;
            display_name: string;
            cloud_storage_object_id: string;
            cloud_storage_object_params: string | null;
            cloud_storage_url: string;
            wx_media_type: "video" | "voice" | "image";
            wx_media_id: string;
            video_title: string | null;
            video_description: string | null;
            wxapi_uploaded_at: number;
            created_at: number;
            updated_at: number | null;
          }[];
          tag: { id: number; name: string };
          qrcode: {
            id: number;
            url: string | null;
            image_url: string | null;
            type: string;
            expiry_time: number | null;
            ticket: string | null;
            is_in_use: boolean | null;
          };
          name: string;
          status: "ACTIVE" | "PAUSE";
          started_at: number | null;
          ended_at: number | null;
          keywords: string[];
          type:
            | "KEYWORD_EXACT"
            | "KEYWORD_PHRASE"
            | "SUBSCRIBE"
            | "DEFAULT"
            | "QRCODE"
            | "LOCATION"
            | "IMAGE"
            | "VOICE"
            | "VIDEO";
          action_type: "reply_single_message" | "reply_all_messages";
          action_params: object | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/auto-reply/${autoReply}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auto Reply
   * @name AccountAutoReplyDelete
   * @summary Delete an auto reply
   * @request DELETE:/org/{org_id}/account/{acc_id}/auto-reply/{auto_reply}
   * @secure
   * @response `200` `{ id: number }`
   */
  accountAutoReplyDelete = (orgId: number, accId: number, autoReply: number, params: RequestParams = {}) =>
    this.request<{ id: number }, any>({
      path: `/org/${orgId}/account/${accId}/auto-reply/${autoReply}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auto Reply
   * @name AccountQrcodeDetail
   * @summary Show qrcode details
   * @request GET:/org/{org_id}/account/{acc_id}/qrcode/{qrcode_id}
   * @secure
   * @response `200` `{ data: { id: number, url: string | null, image_url: string | null, type: "TEMPORARY" | "PERMANENT", expiry_time: number | null, ticket: string | null, is_in_use: boolean | null } }`
   */
  accountQrcodeDetail = (orgId: number, accId: number, qrcodeId: number, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          id: number;
          url: string | null;
          image_url: string | null;
          type: "TEMPORARY" | "PERMANENT";
          expiry_time: number | null;
          ticket: string | null;
          is_in_use: boolean | null;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/qrcode/${qrcodeId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower
   * @name AccountFollowerSearchDetail
   * @summary Search follower
   * @request GET:/org/{org_id}/account/{acc_id}/follower/search
   * @secure
   * @response `200` `{ data: ({ id: number, is_subscribed: boolean | null, open_id: string, union_id: string | null, geo_id: number | null, location: { wxgeo_id: number, parent_id: number | null, iso_num: string, "iso2": string, "iso3": string, name_en: string, name_zh_hans: string, name_zh_hant: string, fullname_en: string, fullname_zh_hans: string, fullname_zh_hant: string, path: string, admin_code: number | null, geoname_id: number | null, short_code: string | null, status: string, remark: string | null }, country: string | null, province: string | null, city: string | null, gender: "MALE" | "FEMALE" | "UNDEFINED" | null, nickname: string | null, remark: string | null, language: "zh_CN" | "zh_TW" | "en" | null, signature: string | null, image_path: string | null, subscribed_at: number | null, last_interaction: number | null, unsubscribed_at: number | null, is_blacklist: boolean | null, tag_ids: (number)[], tags: (({ id: number, name: string }))[] })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully return a list of followers
   */
  accountFollowerSearchDetail = (
    { orgId, accId, ...query }: AccountFollowerSearchDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          is_subscribed: boolean | null;
          open_id: string;
          union_id: string | null;
          geo_id: number | null;
          location: {
            wxgeo_id: number;
            parent_id: number | null;
            iso_num: string;
            iso2: string;
            iso3: string;
            name_en: string;
            name_zh_hans: string;
            name_zh_hant: string;
            fullname_en: string;
            fullname_zh_hans: string;
            fullname_zh_hant: string;
            path: string;
            admin_code: number | null;
            geoname_id: number | null;
            short_code: string | null;
            status: string;
            remark: string | null;
          };
          country: string | null;
          province: string | null;
          city: string | null;
          gender: "MALE" | "FEMALE" | "UNDEFINED" | null;
          nickname: string | null;
          remark: string | null;
          language: "zh_CN" | "zh_TW" | "en" | null;
          signature: string | null;
          image_path: string | null;
          subscribed_at: number | null;
          last_interaction: number | null;
          unsubscribed_at: number | null;
          is_blacklist: boolean | null;
          tag_ids: number[];
          tags: { id: number; name: string }[];
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/follower/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower
   * @name AccountFollowerLanguageDetail
   * @summary Get list of distinct languages
   * @request GET:/org/{org_id}/account/{acc_id}/follower/language
   * @secure
   * @response `200` `{ languages: (string)[] }` Get a list of languages
   */
  accountFollowerLanguageDetail = (orgId: number, accId: number, params: RequestParams = {}) =>
    this.request<{ languages: string[] }, any>({
      path: `/org/${orgId}/account/${accId}/follower/language`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower
   * @name AccountFollowerEstimateTargetsCreate
   * @summary Estimate followers by conditions
   * @request POST:/org/{org_id}/account/{acc_id}/follower/estimate-targets
   * @secure
   * @response `200` `{ result: number }` Retrieve the total number of targets that fit the condition(s) provided
   */
  accountFollowerEstimateTargetsCreate = (
    orgId: number,
    accId: number,
    data: AccountFollowerEstimateTargetsCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<{ result: number }, any>({
      path: `/org/${orgId}/account/${accId}/follower/estimate-targets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower
   * @name AccountFollowerPartialUpdate
   * @summary Update follower by ID
   * @request PATCH:/org/{org_id}/account/{acc_id}/follower/{followerId}
   * @secure
   * @response `200` `{ data: { id: number, is_subscribed: boolean | null, open_id: string, union_id: string | null, geo_id: number | null, location: { wxgeo_id: number, parent_id: number | null, iso_num: string, "iso2": string, "iso3": string, name_en: string, name_zh_hans: string, name_zh_hant: string, fullname_en: string, fullname_zh_hans: string, fullname_zh_hant: string, path: string, admin_code: number | null, geoname_id: number | null, short_code: string | null, status: string, remark: string | null }, country: string | null, province: string | null, city: string | null, gender: "MALE" | "FEMALE" | "UNDEFINED" | null, nickname: string | null, remark: string | null, language: "zh_CN" | "zh_TW" | "en" | null, signature: string | null, image_path: string | null, subscribed_at: number | null, last_interaction: number | null, unsubscribed_at: number | null, is_blacklist: boolean | null, tag_ids: (number)[], tags: (({ id: number, name: string }))[] } }` Successfully updated the follower
   */
  accountFollowerPartialUpdate = (
    orgId: number,
    accId: number,
    followerId: number,
    data: AccountFollowerPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          is_subscribed: boolean | null;
          open_id: string;
          union_id: string | null;
          geo_id: number | null;
          location: {
            wxgeo_id: number;
            parent_id: number | null;
            iso_num: string;
            iso2: string;
            iso3: string;
            name_en: string;
            name_zh_hans: string;
            name_zh_hant: string;
            fullname_en: string;
            fullname_zh_hans: string;
            fullname_zh_hant: string;
            path: string;
            admin_code: number | null;
            geoname_id: number | null;
            short_code: string | null;
            status: string;
            remark: string | null;
          };
          country: string | null;
          province: string | null;
          city: string | null;
          gender: "MALE" | "FEMALE" | "UNDEFINED" | null;
          nickname: string | null;
          remark: string | null;
          language: "zh_CN" | "zh_TW" | "en" | null;
          signature: string | null;
          image_path: string | null;
          subscribed_at: number | null;
          last_interaction: number | null;
          unsubscribed_at: number | null;
          is_blacklist: boolean | null;
          tag_ids: number[];
          tags: { id: number; name: string }[];
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/follower/${followerId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower
   * @name AccountFollowerBatchPartialUpdate
   * @summary Update followers in a batch
   * @request PATCH:/org/{org_id}/account/{acc_id}/follower/batch
   * @secure
   * @response `200` `{ data: ({ id: number, is_subscribed: boolean | null, open_id: string, union_id: string | null, geo_id: number | null, location: { wxgeo_id: number, parent_id: number | null, iso_num: string, "iso2": string, "iso3": string, name_en: string, name_zh_hans: string, name_zh_hant: string, fullname_en: string, fullname_zh_hans: string, fullname_zh_hant: string, path: string, admin_code: number | null, geoname_id: number | null, short_code: string | null, status: string, remark: string | null }, country: string | null, province: string | null, city: string | null, gender: "MALE" | "FEMALE" | "UNDEFINED" | null, nickname: string | null, remark: string | null, language: "zh_CN" | "zh_TW" | "en" | null, signature: string | null, image_path: string | null, subscribed_at: number | null, last_interaction: number | null, unsubscribed_at: number | null, is_blacklist: boolean | null, tag_ids: (number)[], tags: (({ id: number, name: string }))[] })[] }` Successfully updated followers in a batch
   */
  accountFollowerBatchPartialUpdate = (
    orgId: number,
    accId: number,
    data: AccountFollowerBatchPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: {
          id: number;
          is_subscribed: boolean | null;
          open_id: string;
          union_id: string | null;
          geo_id: number | null;
          location: {
            wxgeo_id: number;
            parent_id: number | null;
            iso_num: string;
            iso2: string;
            iso3: string;
            name_en: string;
            name_zh_hans: string;
            name_zh_hant: string;
            fullname_en: string;
            fullname_zh_hans: string;
            fullname_zh_hant: string;
            path: string;
            admin_code: number | null;
            geoname_id: number | null;
            short_code: string | null;
            status: string;
            remark: string | null;
          };
          country: string | null;
          province: string | null;
          city: string | null;
          gender: "MALE" | "FEMALE" | "UNDEFINED" | null;
          nickname: string | null;
          remark: string | null;
          language: "zh_CN" | "zh_TW" | "en" | null;
          signature: string | null;
          image_path: string | null;
          subscribed_at: number | null;
          last_interaction: number | null;
          unsubscribed_at: number | null;
          is_blacklist: boolean | null;
          tag_ids: number[];
          tags: { id: number; name: string }[];
        }[];
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/follower/batch`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower Tag
   * @name AccountFollowerTagDetail
   * @summary Display a listing of tags
   * @request GET:/org/{org_id}/account/{acc_id}/follower-tag
   * @secure
   * @response `200` `{ data: ({ id: number, name: string })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Successfully retrieved a list of tags
   */
  accountFollowerTagDetail = (
    { orgId, accId, name, ...query }: AccountFollowerTagDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        data: { id: number; name: string }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/follower-tag`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower Tag
   * @name AccountFollowerTagCreate
   * @summary Create a tag
   * @request POST:/org/{org_id}/account/{acc_id}/follower-tag
   * @secure
   * @response `200` `{ data: { id: number, name: string } }` Successfully created follower tag, return the tag details
   */
  accountFollowerTagCreate = (
    orgId: number,
    accId: number,
    data: AccountFollowerTagCreatePayload,
    params: RequestParams = {},
  ) =>
    this.request<{ data: { id: number; name: string } }, any>({
      path: `/org/${orgId}/account/${accId}/follower-tag`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower Tag
   * @name AccountFollowerTagDetail2
   * @summary Display the specified tag of provided ID
   * @request GET:/org/{org_id}/account/{acc_id}/follower-tag/{follower_tag}
   * @originalName accountFollowerTagDetail
   * @duplicate
   * @secure
   * @response `200` `{ data: { id: number, name: string } }` Successfully retrieved the tag
   * @response `404` `void` Cannot find a tag with the same ID
   */
  accountFollowerTagDetail2 = (orgId: number, accId: number, followerTag: number, params: RequestParams = {}) =>
    this.request<{ data: { id: number; name: string } }, void>({
      path: `/org/${orgId}/account/${accId}/follower-tag/${followerTag}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower Tag
   * @name AccountFollowerTagPartialUpdate
   * @summary Update the specified tag of provided ID
   * @request PATCH:/org/{org_id}/account/{acc_id}/follower-tag/{follower_tag}
   * @secure
   * @response `200` `{ data: { id: number, name: string } }`
   */
  accountFollowerTagPartialUpdate = (
    orgId: number,
    accId: number,
    followerTag: number,
    data: AccountFollowerTagPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<{ data: { id: number; name: string } }, any>({
      path: `/org/${orgId}/account/${accId}/follower-tag/${followerTag}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Follower Tag
   * @name AccountFollowerTagDelete
   * @summary Update the specified tag of provided ID
   * @request DELETE:/org/{org_id}/account/{acc_id}/follower-tag/{follower_tag}
   * @secure
   * @response `200` `{ id: number, follower_ids: (number)[] }` Successfully removed the tag
   */
  accountFollowerTagDelete = (orgId: number, accId: number, followerTag: number, params: RequestParams = {}) =>
    this.request<{ id: number; follower_ids: number[] }, any>({
      path: `/org/${orgId}/account/${accId}/follower-tag/${followerTag}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name MemberPartialUpdate
   * @summary Update member role by role ID
   * @request PATCH:/org/{org_id}/member/{member_id}
   * @secure
   * @response `200` `{ id: number, name: string, email: string, is_valid: number, is_active: number, language: string, last_login_at: number | null, last_interact_acc: number | null, organization_id: (number)[], organization_role: string, accounts: ({ id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] })[] }` Return current user information
   */
  memberPartialUpdate = (
    orgId: number,
    memberId: number,
    data: MemberPartialUpdatePayload,
    params: RequestParams = {},
  ) =>
    this.request<
      {
        id: number;
        name: string;
        email: string;
        is_valid: number;
        is_active: number;
        language: string;
        last_login_at: number | null;
        last_interact_acc: number | null;
        organization_id: number[];
        organization_role: string;
        accounts: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          member_ids: number[];
          member_admin: number[];
          member_editor: number[];
          member_analyst: number[];
          member_guest: number[];
          role_name: string;
          follower_count: number;
          organization_ids: number[];
        }[];
      },
      any
    >({
      path: `/org/${orgId}/member/${memberId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name MemberDelete
   * @summary delete member
   * @request DELETE:/org/{org_id}/member/{member_id}
   * @secure
   * @response `204` `void` The member was deleted successfully.
   */
  memberDelete = (orgId: number, memberId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/org/${orgId}/member/${memberId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name MemberInviteCreate
   * @summary Send invitation request to member
   * @request POST:/org/{org_id}/member/invite
   * @secure
   * @response `200` `{ id: number, name: string, email: string, is_valid: number, is_active: number, language: string, last_login_at: number | null, last_interact_acc: number | null, organization_id: (number)[], organization_role: string, accounts: ({ id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] })[] }` Return current user information
   */
  memberInviteCreate = (orgId: number, data: MemberInviteCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        id: number;
        name: string;
        email: string;
        is_valid: number;
        is_active: number;
        language: string;
        last_login_at: number | null;
        last_interact_acc: number | null;
        organization_id: number[];
        organization_role: string;
        accounts: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          member_ids: number[];
          member_admin: number[];
          member_editor: number[];
          member_analyst: number[];
          member_guest: number[];
          role_name: string;
          follower_count: number;
          organization_ids: number[];
        }[];
      },
      any
    >({
      path: `/org/${orgId}/member/invite`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name MemberInviteCancelCreate
   * @summary Cancel invitation
   * @request POST:/org/{org_id}/member/invite/cancel
   * @secure
   * @response `200` `{ id: number, name: string, email: string, is_valid: number, is_active: number, language: string, last_login_at: number | null, last_interact_acc: number | null, organization_id: (number)[], organization_role: string, accounts: ({ id: number, status: ("WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE"), is_oversea: boolean, auth_type: ("COMPONENT" | "MANUAL"), nickname: string | null, user_name: string | null, is_verified: number | null, service_type: ("SERVICE" | "SUBSCRIPTION"), app_id: string | null, app_secret: string | null, qrcode_url: string | null, profile_url: string | null, connector_token: string | null, connector_url: string | null, aes_key: string | null, hash_id: string | null, is_open_store: number | null, is_open_scan: number | null, is_open_pay: number | null, is_open_card: number | null, is_open_shake: number | null, is_historical: number | null, is_verified_quali: number | null, is_verified_name: number | null, verify_source: string | null, func_info: string | null, business_info: string | null, permissions: { message_management: boolean, user_management: boolean, account_service: boolean, web_service: boolean, wechat_store: boolean, customer_service: boolean, broadcast_and_notice: boolean, wechat_card: boolean, wechat_scan: boolean, wechat_wifi: boolean, material_management: boolean, wechat_shake: boolean, wechat_poi: boolean, wechat_payment: boolean, custom_menu: boolean }, member_ids: (number)[], member_admin: (number)[], member_editor: (number)[], member_analyst: (number)[], member_guest: (number)[], role_name: string, follower_count: number, organization_ids: (number)[] })[] }` Return current user information
   */
  memberInviteCancelCreate = (orgId: number, data: MemberInviteCancelCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        id: number;
        name: string;
        email: string;
        is_valid: number;
        is_active: number;
        language: string;
        last_login_at: number | null;
        last_interact_acc: number | null;
        organization_id: number[];
        organization_role: string;
        accounts: {
          id: number;
          status: "WAITING" | "ACTIVE" | "PAUSE" | "INCOMPLETE";
          is_oversea: boolean;
          auth_type: "COMPONENT" | "MANUAL";
          nickname: string | null;
          user_name: string | null;
          is_verified: number | null;
          service_type: "SERVICE" | "SUBSCRIPTION";
          app_id: string | null;
          app_secret: string | null;
          qrcode_url: string | null;
          profile_url: string | null;
          connector_token: string | null;
          connector_url: string | null;
          aes_key: string | null;
          hash_id: string | null;
          is_open_store: number | null;
          is_open_scan: number | null;
          is_open_pay: number | null;
          is_open_card: number | null;
          is_open_shake: number | null;
          is_historical: number | null;
          is_verified_quali: number | null;
          is_verified_name: number | null;
          verify_source: string | null;
          func_info: string | null;
          business_info: string | null;
          permissions: {
            message_management: boolean;
            user_management: boolean;
            account_service: boolean;
            web_service: boolean;
            wechat_store: boolean;
            customer_service: boolean;
            broadcast_and_notice: boolean;
            wechat_card: boolean;
            wechat_scan: boolean;
            wechat_wifi: boolean;
            material_management: boolean;
            wechat_shake: boolean;
            wechat_poi: boolean;
            wechat_payment: boolean;
            custom_menu: boolean;
          };
          member_ids: number[];
          member_admin: number[];
          member_editor: number[];
          member_analyst: number[];
          member_guest: number[];
          role_name: string;
          follower_count: number;
          organization_ids: number[];
        }[];
      },
      any
    >({
      path: `/org/${orgId}/member/invite/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Auth
   * @name MemberInviteResendCreate
   * @summary Resend invitation email to member
   * @request POST:/org/{org_id}/member/invite/resend
   * @secure
   * @response `204` `void` The invitation email has sent.
   */
  memberInviteResendCreate = (orgId: number, data: MemberInviteResendCreatePayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/org/${orgId}/member/invite/resend`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Location
   * @name AccountLocationDetail
   * @summary Get locations
   * @request GET:/org/{org_id}/account/{acc_id}/location
   * @secure
   * @response `200` `{ data: ({ wxgeo_id: number, parent_id: number | null, iso_num: string, "iso2": string, "iso3": string, name_en: string, name_zh_hans: string, name_zh_hant: string, fullname_en: string, fullname_zh_hans: string, fullname_zh_hant: string, path: string, admin_code: number | null, geoname_id: number | null, short_code: string | null, status: string, remark: string | null })[], links: { first: string | null, last: string | null, prev: string | null, next: string | null }, meta: { current_page: number | null, from: number | null, last_page: number | null, links: ({ url: string | null, label: string | null, active: boolean | null })[], path: string, per_page: number, to: number, total: number } }` Returns location list
   */
  accountLocationDetail = ({ orgId, accId, ...query }: AccountLocationDetailParams, params: RequestParams = {}) =>
    this.request<
      {
        data: {
          wxgeo_id: number;
          parent_id: number | null;
          iso_num: string;
          iso2: string;
          iso3: string;
          name_en: string;
          name_zh_hans: string;
          name_zh_hant: string;
          fullname_en: string;
          fullname_zh_hans: string;
          fullname_zh_hant: string;
          path: string;
          admin_code: number | null;
          geoname_id: number | null;
          short_code: string | null;
          status: string;
          remark: string | null;
        }[];
        links: { first: string | null; last: string | null; prev: string | null; next: string | null };
        meta: {
          current_page: number | null;
          from: number | null;
          last_page: number | null;
          links: { url: string | null; label: string | null; active: boolean | null }[];
          path: string;
          per_page: number;
          to: number;
          total: number;
        };
      },
      any
    >({
      path: `/org/${orgId}/account/${accId}/location`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
